const TRANSLATIONS = {
    tiw__back: {
        key: "tiw__back",
        ru: "Назад",
        en: "Back",
        kz: "Кері",
        ua: "Назад",
        pl: "Powrót",
        az: "geri qayıt",
    },
    tiw__continue: {
        key: "tiw__continue",
        ru: "Продолжить",
        en: "Continue",
        kz: "Жалғастыру",
        ua: "Продовжити",
        pl: "Dalej",
        az: "Davam etmək",
    },
    tiw__restart: {
        key: "tiw__restart",
        ru: "Начать заново",
        en: "Restart",
        kz: "Қайтадан бастау",
        ua: "Почати заново",
        pl: "Uruchom ponownie",
        az: "Yenidən başla",
    },
    tiw__cancel: {
        key: "tiw__cancel",
        ru: "Отменить",
        en: "Cancel",
        kz: "Бас тарту",
        ua: "Скасувати",
        pl: "Anuluj",
        az: "İmtina etmək",
    },
    tiw__rollDown: {
        key: "tiw__rollDown",
        ru: "Свернуть",
        en: "Roll",
        kz: "Жасыру",
        ua: "Згорнути",
        pl: "W dół",
        az: "Bağlamaq",
    },
    tiw__hide: {
        key: "tiw__hide",
        ru: "Скрыть",
        en: "Hide",
        kz: "Жасыру",
        ua: "Приховати",
        pl: "Ukryj",
        az: "Gizlətmək",
    },
    tiw__close: {
        key: "tiw__close",
        ru: "Закрыть",
        en: "Close",
        kz: "Жабу",
        ua: "Закрити",
        pl: "Zamknij",
        az: "Bağlamaq",
    },
    tiw__notRequired: {
        key: "tiw__notRequired",
        ru: "Не обязательно",
        en: "Not required",
        kz: "Міндетті емес",
        ua: "Не обов'язково",
        pl: "Niewymagane",
        az: "Məcburi deyil",
    },
    tiw__crunch__needHelp: {
        key: "tiw__crunch__needHelp",
        ru: "Нужна помощь? ",
        en: "Do you need help? ",
        kz: "Көмек керек пе? ",
        ua: "Потрібна допомога?",
        pl: "Potrzebujesz pomocy?",
        az: "Kömək lazımdı?",
    },
    tiw__crunch__contactUs: {
        key: "tiw__crunch__contactUs",
        ru: "For assistance and additional details, feel free to view our tutorial video or",
        en: "For assistance and additional details, feel free to view our tutorial video or",
        kz: "For assistance and additional details, feel free to view our tutorial video or",
        ua: "For assistance and additional details, feel free to view our tutorial video or",
        pl: "Aby uzyskać pomoc i dodatkowe informacje, zapraszamy do obejrzenia naszego filmu instruktażowego lub",
        az: "For assistance and additional details, feel free to view our tutorial video or",
    },
    tiw__crunch__contactUsAfter: {
        key: "tiw__crunch__contactUsAfter",
        ru: "contact us",
        en: "contact us",
        kz: "contact us",
        ua: "contact us",
        pl: "skontaktuj się z nami",
        az: "contact us",
    },
    tiw__validation__success: {
        key: "tiw__validation__success",
        ru: "Успешно",
        en: "Successfully",
        kz: "Сәтті",
        ua: "Успішно",
        pl: "Sukces",
        az: "Uğurlu",
    },
    tiw__validation__undefined: {
        key: "tiw__validation__undefined",
        ru: "Для указанного поля валидация не настроена",
        en: "Validation is not configured for the specified field",
        kz: "Көрсетілген өріс үшін валидация орнатылмаған",
        ua: "Для зазначеного поля валідація не налаштована",
        pl: "Walidacja nie jest skonfigurowana dla określonego pola",
        az: "Doğrulama müəyyən edilmiş sahə üçün konfiqurasiya edilməyib.",
    },
    tiw__validation__file_choosePhoto: {
        key: "tiw__validation__file_choosePhoto",
        ru: "Загрузите фото",
        en: "Select a photo",
        kz: "Фотосуретті таңдаңыз",
        ua: "Виберіть фото",
        pl: "Wybierz zdjęcie",
        az: "Şəkili seçin",
    },
    tiw__validation__file_maxSize: {
        key: "tiw__validation__file_maxSize",
        ru: "Превышен максимально допустимый (10 мб) размер файла. Выберите другое фото",
        en: "The maximum allowed file size (10 MB) has been exceeded. Choose another photo",
        kz: "Рұқсат етілген ең үлкен (10 мб) файл өлшемінен асып кетті. Басқа фотосуретті таңдаңыз",
        ua: "Перевищено максимально допустимий (10 Мб) розмір файлу. Виберіть інше фото",
        pl: "Przekroczono maksymalny dozwolony rozmiar pliku (10 MB). Wybierz inne zdjęcie",
        az: "Maksimum fayl ölçüsü (10 MB) aşıldı. Başqa bir şəkil seçin",
    },
    tiw__validation__file_wrongExt: {
        key: "tiw__validation__file_wrongExt",
        ru: 'Расширение загружаемого Вами файла не поддерживается для загрузки. Допустимы файлы с расширением ".jpg, .jpeg, .DNG, .png или .heic"',
        en: 'The file extension you are downloading is not supported for download. Files with the extension " are allowed.jpg, .jpeg, .DNG, .png or .heic"',
        kz: 'Сіз жүктеген файл кеңейтіміне жүктеу үшін қолдау көрсетілмейді. Кеңейтімі бар файлдар жарамды ".jpg, .jpeg, .DNG, .png немесе .heic"',
        ua: 'Розширення файлу, що завантажується, не підтримується для завантаження. Допустимі файли з розширенням ".jpg, .jpeg, .DNG, .png або .heic"',
        pl: 'Rozszerzenie pobieranego pliku nie jest obsługiwane. Dozwolone są pliki z rozszerzeniem ".jpg, .jpeg, .DNG, .png lub .heic"',
        az: 'Yüklədiyiniz faylın genişləndirilməsi yükləmə üçün dəstəklənmir. ".jpg, .jpeg, .DNG, .png və ya .heic" uzantılı fayllar qəbul edilir.',
    },
    tiw__validation__required: {
        key: "tiw__validation__required",
        ru: "Поле обязательно к заполнению",
        en: "The field must be filled in",
        kz: "The field must be filled in",
        ua: "Поле обов'язкове для заповнення",
        pl: "Pole musi być wypełnione",
        az: "The field must be filled in",
    },
    tiw__validation__fio_required: {
        key: "tiw__validation__fio_required",
        ru: "Поле ФИО обязательно к заполнению",
        en: "The full name field must be filled in",
        kz: "Аты жөні өрісі міндетті түрде толтырылады",
        ua: "Поле ПІБ обов'язкове для заповнення",
        pl: "Pole 'Pełne Imię' musi być wypełnione",
        az: "SAA sahəsinin doldurulması tələb olunur",
    },
    tiw__validation__fio_range: {
        key: "tiw__validation__fio_range",
        ru: "Поле ФИО должно иметь от 6 до 50 символов",
        en: "The full name field must have from 6 to 50 characters",
        kz: "Аты жөні өрісінде 6 дан 50 ге дейін таңба болуы керек",
        ua: "Поле ПІБ повинно мати від 6 до 50 символів",
        pl: "Pole 'Pełne Imię' musi zawierać od 6 do 50 znaków.",
        az: "SAA sahəsi 10 ilə 50 simvol arasında olmalıdır.",
    },
    tiw__validation__fio_symbols: {
        key: "tiw__validation__fio_symbols",
        ru: 'Поле ФИО содержит недопустимые символы пунктуации кроме "-" или повторяющийся 2 раза под ряд символ пробела',
        en: 'The FULL NAME field contains invalid punctuation characters other than "-" or a space character repeated 2 times in a row',
        kz: 'Аты-жөні өрісінде "-" немесе қатарынан 2 рет қайталанатын бос орыннан басқа рұқсат етілмеген тыныс белгілері бар',
        ua: 'Поле ПІБ містить неприпустимі символи пунктуації крім "-" або повторюваний 2 рази підряд символ пробілу',
        pl: 'Pole PEŁNE IMIĘ zawiera nieprawidłowe znaki interpunkcyjne inne niż "-" lub znak spacji powtórzony 2 razy z rzędu',
        az: 'SAA sahəsində "-" və ya ardıcıl iki dəfə təkrarlanan boşluq simvolundan başqa etibarsız durğu işarələri var',
    },
    tiw__validation__imei_required: {
        key: "tiw__validation__imei_required",
        ru: "Поле IMEI обязательно к заполнению",
        en: "The IMEI field must be filled in",
        kz: "IMEI өрісі міндетті түрде толтырылады",
        ua: "Поле IMEI обов'язкове до заповнення",
        pl: "Pole IMEI musi być wypełnione",
        az: "IMEI sahəsi tələb olunur.",
    },
    tiw__validation__imei_range: {
        key: "tiw__validation__imei_range",
        ru: "Поле IMEI должно состоять только из цифр и не менее 15 символов",
        en: "The IMEI field must consist of only numbers and at least 15 characters",
        kz: "IMEI өрісі тек сандардан және кем дегенде 15 таңбадан тұруы керек",
        ua: "Поле IMEI має складатися лише з цифр і не менше ніж 15 символів",
        pl: "Pole IMEI musi składać się wyłącznie z cyfr i co najmniej 15 znaków",
        az: "IMEI sahəsi yalnız rəqəmlərdən ibarət olmalı və ən azı 15 simvol uzunluğunda olmalıdır.",
    },
    tiw__validation__inn_required: {
        key: "tiw__validation__inn_required",
        ru: "Поле ИНН обязательно к заполнению",
        en: "The INN field must be filled in",
        kz: "СТН өрісі міндетті түрде толтырылады",
        ua: "Поле ІПН обов'язкове до заповнення",
        pl: "Pole INN musi być wypełnione",
        az: "VÖEN sahəsi tələb olunur.",
    },
    tiw__validation__inn_range: {
        key: "tiw__validation__inn_range",
        ru: "Поле ИНН должно состоять только из цифр и в диапазоне 10-12 символов",
        en: "The INN field should consist only of numbers and in the range of 10-12 characters",
        kz: "СТН өрісі тек сандардан және 10-12 таңбадан тұруы керек",
        ua: "Поле ІПН має складатися тільки з цифр і в діапазоні 10-12 символів",
        pl: "Pole INN powinno składać się wyłącznie z cyfr i zawierać od 10 do 12 znaków",
        az: "VÖEN sahəsi yalnız rəqəmlərdən ibarət olmalı və 10-12 simvol diapazonunda olmalıdır.",
    },
    tiw__validation__id_number_required: {
        key: "tiw__validation__id_number_required",
        ru: "The ID Number field must be filled in",
        en: "The ID Number field must be filled in",
        kz: "The ID Number field must be filled in",
        ua: "The ID Number field must be filled in",
        pl: "The ID Number field must be filled in",
        az: "The ID Number field must be filled in",
    },
    tiw__validation__id_number_range: {
        key: "tiw__validation__id_number_range",
        ru: "The ID Number field should consist only of numbers and 13 characters",
        en: "The ID Number field should consist only of numbers and 13 characters",
        kz: "The ID Number field should consist only of numbers and 13 characters",
        ua: "The ID Number field should consist only of numbers and 13 characters",
        pl: "The ID Number field should consist only of numbers and 13 characters",
        az: "The ID Number field should consist only of numbers and 13 characters",
    },
    tiw__validation__email_required: {
        key: "tiw__validation__email_required",
        ru: "Поле Email обязательно к заполнению",
        en: "The Email field must be filled in",
        kz: "Email өрісі міндетті түрде толтырылады",
        ua: "Поле Email обов'язкове до заповнення",
        pl: "Pole Email musi być wypełnione",
        az: "E-poçt sahəsi tələb olunur.",
    },
    tiw__validation__email_incorrect: {
        key: "tiw__validation__email_incorrect",
        ru: "Введите корректный Email",
        en: "Enter the correct Email address",
        kz: "Дұрыс электрондық поштаны енгізіңіз",
        ua: "Введіть правильний Email",
        pl: "Wprowadź poprawny adres e-mail",
        az: "Düzgün E-poçtu daxil edin",
    },
    tiw__validation__date_required: {
        key: "tiw__validation__date_required",
        ru: "Поле Дата обязательно к заполнению",
        en: "The Date field must be filled in",
        kz: "Date өрісі міндетті түрде толтырылады",
        ua: "Поле Дата обов'язкове до заповнення",
        pl: "Pole Date musi być wypełnione",
        az: "Telefon sahəsi tələb olunur.",
    },
    tiw__validation__date_incorrect: {
        key: "tiw__validation__date_incorrect",
        ru: "Введите корректную дату",
        en: "Enter the correct Date address",
        kz: "Дұрыс Date енгізіңіз",
        ua: "Введіть правильну дату",
        pl: "Wprowadź poprawny adres date",
        az: "Enter the correct Date address",
    },
    tiw__validation__phone_required: {
        key: "tiw__validation__phone_required",
        ru: "Поле Телефон обязательно к заполнению",
        en: "The Phone field must be filled in",
        kz: "Телефон өрісі міндетті түрде толтырылады",
        ua: "Поле Телефон обов'язкове до заповнення",
        pl: "Pole Telefon musi być wypełnione",
        az: "The Phone field must be filled in",
    },
    tiw__validation__phone_range: {
        key: "tiw__validation__phone_range",
        ru: "Поле Телефон должно быть в диапазоне 14-18 символов",
        en: "The Phone field should be in the range of 14-18 characters",
        kz: "Телефон өрісі 14-18 таңбадан тұруы керек",
        ua: "Поле Телефон має бути в діапазоні 14-18 символів",
        pl: "Pole Telefon powinno zawierać od 14 do 18 znaków",
        az: "Telefon sahəsi 14-18 simvol arasında olmalıdır.",
    },
    tiw__grades__Q_stateInfo: {
        key: "tiw__grades__Q_stateInfo",
        ru: "Идеальное",
        en: "Perfect",
        kz: "Mінсіз",
        ua: "Ідеальне",
        pl: "Idealny",
        az: "Mükəmməl",
    },
    tiw__grades__Q_description: {
        key: "tiw__grades__Q_description",
        ru: "Устройство в идеальном состоянии",
        en: "The device is in perfect condition",
        kz: "Құрылғы мінсіз күйде",
        ua: "Пристрій в ідеальному стані",
        pl: "Urządzenie jest w idealnym stanie",
        az: "Cihaz ideal vəziyyətdədir",
    },
    "tiw__grades__A+_stateInfo": {
        key: "tiw__grades__A+_stateInfo",
        ru: "Идеальное",
        en: "Perfect",
        kz: "Mінсіз",
        ua: "Ідеальне",
        pl: "Idealny",
        az: "Mükəmməl",
    },
    "tiw__grades__A+_description": {
        key: "tiw__grades__A+_description",
        ru: "Устройство в идеальном состоянии",
        en: "The device is in perfect condition",
        kz: "Құрылғы мінсіз күйде",
        ua: "Пристрій в ідеальному стані",
        pl: "Urządzenie jest w idealnym stanie",
        az: "Cihaz ideal vəziyyətdədir",
    },
    tiw__grades__A_stateInfo: {
        key: "tiw__grades__A_stateInfo",
        ru: "Отличное",
        en: "Excellent",
        kz: "Өте жақсы",
        ua: "Відмінне",
        pl: "Doskonały",
        az: "Əla",
    },
    tiw__grades__A_description: {
        key: "tiw__grades__A_description",
        ru: "Устройство в отличном состоянии",
        en: "The device is in excellent condition",
        kz: "Құрылғы өте жақсы күйде",
        ua: "Пристрій у відмінному стані",
        pl: "Urządzenie jest w doskonałym stanie",
        az: "Cihaz əla vəziyyətdədir",
    },
    tiw__grades__B_stateInfo: {
        key: "tiw__grades__B_stateInfo",
        ru: "Хорошее",
        en: "Good",
        kz: "Жақсы",
        ua: "Гарне",
        pl: "Dobry",
        az: "yaxşı",
    },
    tiw__grades__B_description: {
        key: "tiw__grades__B_description",
        ru: "Устройство в хорошем состоянии",
        en: "The device is in good condition",
        kz: "Құрылғы жақсы күйде",
        ua: "Пристрій у гарному стані",
        pl: "Urządzenie jest w dobrym stanie",
        az: "Cihaz yaxşı vəziyyətdədir",
    },
    tiw__grades__C_stateInfo: {
        key: "tiw__grades__C_stateInfo",
        ru: "Со следами эксплуатации",
        en: "With traces of exploitation",
        kz: "Пайдалану іздері бар",
        ua: "Зі слідами експлуатації",
        pl: "Ze śladami użytkowania",
        az: "İstifadə izləri ilə",
    },
    tiw__grades__C_description: {
        key: "tiw__grades__C_description",
        ru: "Устройство со следами эксплуатации",
        en: "A device with traces of operation",
        kz: "Пайдалану іздері бар құрылғы",
        ua: "Пристрій зі слідами експлуатації",
        pl: "Urządzenie ze śladami użytkowania",
        az: "Cihaz istifadə izləri ilə",
    },
    tiw__grades__D_stateInfo: {
        key: "tiw__grades__D_stateInfo",
        ru: "Со значительными следами эксплуатации",
        en: "With significant traces of exploitation",
        kz: "Пайдаланудың елеусіз іздері бар",
        ua: "Зі значними слідами експлуатації",
        pl: "Ze znacznymi śladami użytkowania",
        az: "Əhəmiyyətli istifadə izləri ilə",
    },
    tiw__grades__D_description: {
        key: "tiw__grades__D_description",
        ru: "Устройство со значительными следами эксплуатации",
        en: "A device with significant traces of operation",
        kz: "Елеулісіз пайдалану іздері бар құрылғы",
        ua: "Пристрій зі значними слідами експлуатації",
        pl: "Urządzenie ze znaczącymi śladami użytkowania",
        az: "Cihaz əhəmiyyətli istifadə izləri ilə",
    },
    tiw__grades__E_stateInfo: {
        key: "tiw__grades__E_stateInfo",
        ru: "Критическое",
        en: "Critical",
        kz: "Сыни",
        ua: "Критичне",
        pl: "Krytyczny",
        az: "Kritik",
    },
    tiw__grades__E_description: {
        key: "tiw__grades__E_description",
        ru: "Устройство с критическими дефектами",
        en: "A device with critical defects",
        kz: "Сыни ақаулары бар құрылғы",
        ua: "Пристрій з критичними дефектами",
        pl: "Urządzenie z krytycznymi usterkami",
        az: "Kritik qüsurları olan cihaz",
    },
    tiw__vselect__notFound: {
        key: "tiw__vselect__notFound",
        ru: "Извините. Совпадений не найдено.",
        en: "Sorry. No matches were found.",
        kz: "Кешіріңіз. Сәйкестік табылған жоқ.",
        ua: "Вибачте. Збігів не знайдено.",
        pl: "Przepraszamy. Nie znaleziono dopasowań.",
        az: "Bağışlayın. Heç bir uyğunluq tapılmadı.",
    },
    tiw__salesDevice__title: {
        key: "tiw__salesDevice__title",
        ru: "Покупаемое устройство",
        en: "The device to be sale",
        kz: "Сатып алынатын құрылғы",
        ua: "Пристрій, що купується",
        pl: "Nowe urządzenie kupowane",
        az: "Alınan cihaz",
    },
    tiw__handedDevice__title: {
        key: "tiw__handedDevice__title",
        ru: "Сдаваемое устройство",
        en: "The device to be handed over",
        kz: "Өткізілетін құрылғы",
        ua: "Пристрій, що здається",
        pl: "Urządzenie do odkupu",
        az: "verilən cihaz",
    },
    tiw__handedDevice__opportunity: {
        key: "tiw__handedDevice__opportunity",
        ru: "Вы можете загрузить дополнительные фото согласно инструкции, в этом случае стоимость выкупа может быть увеличена",
        en: "You can upload additional photos according to the instructions, in which case the purchase price may be increased",
        kz: "Нұсқаулыққа сәйкес қосымша фотосуреттерді жүктеуге болады, бұл жағдайда сатып алу құнын артуы мүмкін",
        ua: "Ви можете завантажити додаткові фото згідно з інструкцією, у цьому випадку вартість викупу може бути збільшена",
        pl: "Możesz przesłać dodatkowe zdjęcia zgodnie z instrukcjami, w takim przypadku wartość odkupu może wzrosnąć.",
        az: "Təlimatlara uyğun olaraq əlavə fotoşəkillər yükləyə bilərsiniz, bu halda alış qiyməti artırıla bilər",
    },
    tiw__handedDevice__unknownGrade: {
        key: "tiw__handedDevice__unknownGrade",
        ru: "Состояние устройства не определено",
        en: "The device status is not defined",
        kz: "Құрылғының күйі анықталмады",
        ua: "Стан пристрою не визначено",
        pl: "Grade urządzenia nie został określony",
        az: "Cihazın vəziyyəti müəyyən edilməyib",
    },
    tiw__handedDevice__deviceTerminated: {
        key: "tiw__handedDevice__deviceTerminated",
        ru: "К сожалению, данное устройство в таком состоянии выкупу не подлежит",
        en: "Unfortunately, this device is not redeemable in this condition",
        kz: "Өкінішке орай, бұл құрылғы мұндай жағдайда сатып алуға жатпайды",
        ua: "На жаль, цей пристрій у такому стані викупу не підлягає",
        pl: "Niestety, to urządzenie nie może zostać odkupione w tym stanie",
        az: "Təəssüf ki, bu vəziyyətdə olan bu cihaz geri alına bilməz.",
    },
    tiw__handedDevice__samsungS26Bonus: {
        key: "tiw__handedDevice__samsungS26Bonus",
        ru: "Consider buying",
        en: "Consider buying",
        kz: "Consider buying",
        ua: "Consider buying",
        pl: "Dodatkowy bonus za zakup w ramach wymiany",
        az: "Consider buying",
    },
    tiw__calculatedDevice__title_pre: {
        key: "tiw__calculatedDevice__title_pre",
        ru: "Предварительная цена",
        en: "Preliminary price",
        kz: "Алдын ала бағасы",
        ua: "Попередня ціна",
        pl: "Wycena wstępna",
        az: "İlkin qiymət",
    },
    tiw__calculatedDevice__title_fin: {
        key: "tiw__calculatedDevice__title_fin",
        ru: "Финальная цена",
        en: "Final price",
        kz: "Соңғы баға",
        ua: "Фінальна ціна",
        pl: "Wycena końcowa",
        az: "Yekun qiymət",
    },
    tiw__calculatedDevice__price_list_costNewDevice: {
        key: "tiw__calculatedDevice__price_list_costNewDevice",
        ru: "Цена нового устройства",
        en: "The price of a new device",
        kz: "Жаңа құрылғының бағасы",
        ua: "Ціна нового пристрою",
        pl: "Wycena nowego urządzenia",
        az: "Yeni cihazın qiyməti",
    },
    tiw__calculatedDevice__price_list_tradeInSale: {
        key: "tiw__calculatedDevice__price_list_tradeInSale",
        ru: "Скидка в Trade-In",
        en: "Trade-In sale",
        kz: "Trade-in-гі жеңілдік",
        ua: "Вигода у Trade-In",
        pl: "Sprzedaż w ramach odkupu",
        az: "Trade-in endrimi",
    },
    tiw__calculatedDevice__price_list_tradeInSale_from: {
        key: "tiw__calculatedDevice__price_list_tradeInSale_from",
        ru: "от [[PRICE]] [[CURRENCY]]",
        en: "from [[PRICE]] [[CURRENCY]]",
        kz: "[[PRICE]] [[CURRENCY]] бастап",
        ua: "від [[PRICE]] [[CURRENCY]]",
        pl: "od [[PRICE]] [[CURRENCY]]",
        az: "[[PRICE]] [[CURRENCY]] başlayaraq",
    },
    tiw__calculatedDevice__price_list_tradeInSale_until: {
        key: "tiw__calculatedDevice__price_list_tradeInSale_until",
        ru: "до [[PRICE]] [[CURRENCY]]",
        en: "until [[PRICE]] [[CURRENCY]]",
        kz: "[[PRICE]] [[CURRENCY]] дейін",
        ua: "до [[PRICE]] [[CURRENCY]]",
        pl: "do [[PRICE]] [[CURRENCY]].",
        az: "[[PRICE]] [[CURRENCY]] kimi",
    },
    tiw__calculatedDevice__price_list_additionalSale: {
        key: "tiw__calculatedDevice__price_list_additionalSale",
        ru: "Экстра-бонус за покупку в Trade-in",
        en: "Extra bonus for buying in Trade-in",
        kz: "Trade-in-де сатып алу үшін экстра-бонус",
        ua: "Екстра-бонус за покупку в Trade-in",
        pl: "Dodatkowy bonus za zakup w ramach odkupu",
        az: "Trade-in-də alış üçün əlavə bonus",
    },
    tiw__calculatedDevice__price_list_additionalSale_valid: {
        key: "tiw__calculatedDevice__price_list_additionalSale_valid",
        ru: "Действует с [[START]] до [[END]]",
        en: "Valid from [[START]] to [[END]]",
        kz: "[[START]] бастап [[END]] дейін жарамды",
        ua: "Діє з [[START]] до [[END]]",
        pl: "Obowiązuje od [[START]] do [[END]]",
        az: "[[START]] tarixindən [[END]] tarixinə qədər etibarlıdır",
    },
    tiw__calculatedDevice__price_list_tradeInInfo: {
        key: "tiw__calculatedDevice__price_list_tradeInInfo",
        ru: "Эта сумма определена на основании ваших ответов и является предварительной. Вы узнаете точный размер скидки, как только устройство проверит наш эксперт. В 86% случаев финальная оценка совпадает с предварительной.",
        en: "This amount is determined based on your answers and is preliminary. You will find out the exact discount amount as soon as our expert checks the device. In 86% of cases, the final assessment coincides with the preliminary one.",
        kz: "ұл сома сіздің жауаптарыңыз негізінде анықталады және алдын ала баға болып табылады. Жеңілдіктің нақты мөлшерін біздің сарапшы текесергеннен кейін білетін боласыз. 86% жағдайда соңғы бағалау алдын ала бағалаумен сәйкес келеді.",
        ua: "Ця сума визначена на підставі ваших відповідей та є попередньою. Ви дізнаєтесь точний розмір вигоди, як тільки пристрій перевірить наш експерт. У 86% випадків фінальна оцінка збігається з попередньою.",
        pl: "Kwota ta jest określana na podstawie udzielonych odpowiedzi i ma charakter wstępny. Dokładną kwotę odkupu poznasz, gdy tylko nasz ekspert sprawdzi urządzenie. W 86% przypadków ostateczna wycena pokrywa się z wyceną wstępną.",
        az: "Bu məbləğ sizin cavablarınız əsasında müəyyən edilir və ilkindir. Ekspertimiz cihazı yoxladıqdan sonra endirimin dəqiq məbləğini biləcəksiniz. 86% hallarda yekun qiymətləndirmə ilkin qiymətləndirmə ilə üst-üstə düşür.",
    },
    tiw__loadPanel__downloadPhoto: {
        key: "tiw__loadPanel__downloadPhoto",
        ru: "Загрузить фото",
        en: "Upload a photo",
        kz: "Фотоны жүктеу",
        ua: "Завантажити фото",
        pl: "Prześlij zdjęcie",
        az: "Foto yükləyin",
    },
    tiw__loadPanel__downloadPhoto_err: {
        key: "tiw__loadPanel__downloadPhoto_err",
        ru: "Загрузите фото",
        en: "Upload a photo",
        kz: "Фотосуретті жүктеңіз",
        ua: "Завантажте фото",
        pl: "Prześlij zdjęcie",
        az: "Foto yükləyin",
    },
    tiw__loadPanel__downloadPhoto_ambiguous: {
        key: "tiw__loadPanel__downloadPhoto_ambiguous",
        ru: "Чтобы уточнить грейд сделайте дополнительные фото",
        en: "To clarify the grade, take additional photos",
        kz: "Грейдті нақтылау үшін қосымша фотосуреттер түсіріңіз",
        ua: "Щоб уточнити грейд, зробіть додаткові фото",
        pl: "Aby doprecyzować ocenę, zrób dodatkowe zdjęcia",
        az: "Qiyməti aydınlaşdırmaq üçün əlavə fotoşəkillər çəkin",
    },
    tiw__loadPanel__downloadPhoto_badQuality: {
        key: "tiw__loadPanel__downloadPhoto_badQuality",
        ru: "Фото плохого качества",
        en: "Photos of poor quality",
        kz: "Сапасыз фотосурет",
        ua: "Фото поганої якості",
        pl: "Zdjęcia niskiej jakości",
        az: "Keyfiyyətsiz şəkil",
    },
    tiw__loadPanel__downloadPhoto_irrelevant: {
        key: "tiw__loadPanel__downloadPhoto_irrelevant",
        ru: "Фото не соответствует требованию",
        en: "Photos is irrelevant",
        kz: "Фото талапқа сәйкес келмейді",
        ua: "Фото не відповідає вимогам",
        pl: "Zdjęcia nie spełniają wymagań",
        az: "Foto tələblərə cavab vermir",
    },
    tiw__qrPanel__title: {
        key: "tiw__qrPanel__title",
        ru: "QR для загрузки с телефона",
        en: "Scan the QR code to upload photos from a phone",
        kz: "Телефоннан жүктеуге арналған QR",
        ua: "QR для завантаження з телефону",
        pl: "Zeskanuj kod QR drugim telefonem, aby dodać zdjęcia.",
        az: "Telefondan yükləmək üçün QR",
    },
    tiw__qrPanel__info: {
        key: "tiw__qrPanel__info",
        ru: "Если у вас нет фото сдаваемого устройства, отсканируйте QR-код камерой телефона и загрузите их для продолжения заявки.",
        en: "To do this, scan the QR code from your phone. After The photos will be uploaded from your phone, you can continue registration of the application.",
        kz: "Ол үшін телефоныңыздан  QR кодты сканерлеңіз. Фотосуреттер телефоннан жүктелген кезде, Сіз өтінішті рәсімдеуді жалғастыра аласыз.",
        ua: "Якщо у вас немає фото пристрою, що здається, відскануйте QR-код камерою телефону і завантажте їх для продовження заявки.",
        pl: "Po przesłaniu zdjęć przejdziesz dalej.",
        az: "Əgər alınan cihazın şəkli yoxdursa, telefonunuzun kamerası ilə QR kodunu skan edin və tətbiqinizi davam etdirmək üçün onları yükləyin.",
    },
    tiw__buyDevice__title: {
        key: "tiw__buyDevice__title",
        ru: "Какое устройство вы хотите купить?",
        en: "Which device do you want to buy?",
        kz: "Сіз қандай құрылғыны сатып алғыңыз келеді?",
        ua: "Який пристрій ви хочете купити?",
        pl: "Jakie urządzenie chcesz kupić?",
        az: "Hansı cihazı almaq istəyirsiniz?",
    },
    tiw__buyDevice__subtitle: {
        key: "tiw__buyDevice__subtitle",
        ru: "Выберите желаемую модель",
        en: "Select the desired model",
        kz: "Қажетті модельді таңдаңыз",
        ua: "Виберіть бажану модель",
        pl: "Wybierz model",
        az: "İstədiyiniz modeli seçin",
    },
    tiw__buyDevice__brand: {
        key: "tiw__buyDevice__brand",
        ru: "Бренд",
        en: "Brand",
        kz: "Бренд",
        ua: "Бренд",
        pl: "Marka",
        az: "Brend",
    },
    tiw__buyDevice__category: {
        key: "tiw__buyDevice__category",
        ru: "Категория",
        en: "Category",
        kz: "Санат",
        ua: "Категорія",
        pl: "Kategoria",
        az: "Kateqoriya",
    },
    tiw__buyDevice__model: {
        key: "tiw__buyDevice__model",
        ru: "Модель",
        en: "Model",
        kz: "Үлгі",
        ua: "Модель",
        pl: "Model",
        az: "Model",
    },
    tiw__chooseDevice__title: {
        key: "tiw__chooseDevice__title",
        ru: "Какое устройство вы хотите сдать?",
        en: "Which device do you want to trade-in?",
        kz: "Қандай құрылғыны өткізгіңіз келеді?",
        ua: "Який пристрій ви хочете здати?",
        pl: "Wybierz model urządzenia, aby przejść do wyceny.",
        az: "Hansı cihazı təhvil vermək istərdiniz?",
    },
    tiw__chooseDevice__subtitle: {
        key: "tiw__chooseDevice__subtitle",
        ru: "Укажите модель, чтобы узнать размер скидки",
        en: "Specify the model to find out the discount amount",
        kz: "Жеңілдік мөлшерін білу үшін моделін көрсетіңіз",
        ua: "Вкажіть модель, щоб дізнатися розмір вигоди",
        pl: "Podaj model telefonu, by dowiedzieć się, ile za niego dostaniesz.",
        az: "Endirim məbləğini öyrənmək üçün modeli göstərin",
    },
    tiw__chooseDevice__brand: {
        key: "tiw__chooseDevice__brand",
        ru: "Бренд",
        en: "Brand",
        kz: "Бренд",
        ua: "Бренд",
        pl: "Marka",
        az: "Brend",
    },
    tiw__chooseDevice__category: {
        key: "tiw__chooseDevice__category",
        ru: "Категория",
        en: "Category",
        kz: "Санат",
        ua: "Категорія",
        pl: "Kategoria",
        az: "Kateqoriya",
    },
    tiw__chooseDevice__model: {
        key: "tiw__chooseDevice__model",
        ru: "Модель",
        en: "Model",
        kz: "Үлгі",
        ua: "Модель",
        pl: "Model",
        az: "Model",
    },
    tiw__chooseDevice__other: {
        key: "tiw__chooseDevice__other",
        ru: "Память / Модель / Год",
        en: "Memory / Model / Year",
        kz: "Жад / Өлшемі / Жылы",
        ua: "Пам'ять / Модель / Рік",
        pl: "Pamięć / Model / Rok",
        az: "Yaddaş / Model / İl",
    },
    tiw__chooseDevice__color: {
        key: "tiw__chooseDevice__color",
        ru: "Цвет",
        en: "Color",
        kz: "Түсі",
        ua: "Колір",
        pl: "Kolor",
        az: "Rəng",
    },
    tiw__chooseDevice__terms: {
        key: "tiw__chooseDevice__terms",
        ru: 'Больше информации вы найдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">Условиях использования Breezy Trade-In</a>.',
        en: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">Breezy Trade-In Terms of Uses </a>.',
        kz: '<a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.',
        ua: 'Більше інформації ви знайдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">Умовах використання Breezy Trade-In</a>.',
        pl: 'Więcej informacji w <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">Regulamin Odkupu Breezy</a>.',
        az: 'Ətraflı məlumat üçün <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">Breezy Trade-In İstifadə Şərtlərinə</a> baxın.',
    },
    tiw__chooseDevice__terms__ua_breezy: {
        key: "tiw__chooseDevice__terms__ua_breezy",
        ru: 'Больше информации вы найдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf">Условиях использования Breezy Trade-In</a>.',
        en: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf">Breezy Trade-In Terms of Uses </a>.',
        kz: '<a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.',
        ua: 'Більше інформації ви знайдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf">Умовах використання Breezy Trade-In</a>.',
        pl: 'Więcej informacji w <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf">Regulamin Odkupu Breezy</a>.',
        az: 'Ətraflı məlumat üçün <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/wp-content/uploads/2025/07/trade_in_legal.pdf">Breezy Trade-In İstifadə Şərtlərinə</a> baxın.',
    },
    tiw__chooseDevice__terms__ua_foxtrot: {
        key: "tiw__chooseDevice__terms__ua_foxtrot",
        ru: 'Больше информации вы найдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/trade-in-legal_Foxtrot.pdf">Условиях использования Breezy Trade-In</a>.',
        en: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/trade-in-legal_Foxtrot.pdf">Breezy Trade-In Terms of Uses </a>.',
        kz: '<a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/trade-in-legal_Foxtrot.pdf">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.',
        ua: 'Більше інформації ви знайдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/trade-in-legal_Foxtrot.pdf">Умовах використання Breezy Trade-In</a>.',
        pl: 'Więcej informacji w <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/trade-in-legal_Foxtrot.pdf">Regulamin Odkupu Breezy</a>.',
        az: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://breezy.band/trade-in-legal_Foxtrot.pdf">Breezy Trade-In Terms of Uses </a>.',
    },
    tiw__chooseDevice__terms__za_avo_africa: {
        key: "tiw__chooseDevice__terms__za_avo_africa",
        ru: 'Больше информации вы найдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf">Условиях использования Breezy Trade-In</a>.',
        en: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf">Breezy Trade-In Terms of Uses </a>.',
        kz: '<a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.',
        ua: 'Більше інформації ви знайдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf">Умовах використання Breezy Trade-In</a>.',
        pl: 'Więcej informacji w <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf">Regulamin Odkupu Breezy</a>.',
        az: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/nedbank_general_t_and_cs.pdf">Breezy Trade-In Terms of Uses </a>.',
    },
    tiw__chooseDevice__terms__za_dg_co: {
        key: "tiw__chooseDevice__terms__za_dg_co",
        ru: 'Больше информации вы найдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf">Условиях использования Breezy Trade-In</a>.',
        en: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf">Breezy Trade-In Terms of Uses </a>.',
        kz: '<a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf">Қосымша ақпаратты Breezy Trade-In</a> пайдалану шарттарынан таба аласыз.',
        ua: 'Більше інформації ви знайдете в <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf">Умовах використання Breezy Trade-In</a>.',
        pl: 'Więcej informacji w <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf">Regulamin Odkupu Breezy</a>.',
        az: 'You will find more information in the <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/digital_generation_general_t_and_cs.pdf">Breezy Trade-In Terms of Uses </a>.',
    },
    tiw__chooseDevice_deviceNotAccepted: {
        key: "tiw__chooseDevice_deviceNotAccepted",
        ru: "К сожалению данное устройство не принимается",
        en: "Unfortunately, this device is not accepted",
        kz: "Бұл құрылғыны қабылдауға жатпайды",
        ua: "На жаль, цей пристрій не приймається",
        pl: "Niestety, nie możemy zaakceptować tego urządzenia",
        az: "Təəssüf ki, bu cihaz qəbul edilmir.",
    },
    tiw__chooseDeviceToBuy_title: {
        key: "tiw__chooseDeviceToBuy_title",
        ru: "Please select the model of the device you are purchasing",
        kz: "Please select the model of the device you are purchasing",
        ua: "Please select the model of the device you are purchasing",
        az: "Please select the model of the device you are purchasing",
        en: "Please select the model of the device you are purchasing",
        pl: "Jakie nowe urządzenie chcesz kupić? (opcjonalnie)",
    },
    tiw__chooseDeviceToBuy_otherDevice: {
        key: "tiw__chooseDeviceToBuy_otherDevice",
        ru: "Other device",
        kz: "Other device",
        ua: "Other device",
        az: "Other device",
        en: "Other device",
        pl: "Inne urządzenie",
    },
    tiw__howYouRateDevice__howGetSale: {
        key: "tiw__howYouRateDevice__howGetSale",
        ru: "Как получить скидку",
        en: "How to get a discount",
        kz: "Жеңілдікті қалай алуға болады",
        ua: "Як отримати вигоду",
        pl: "Jak otrzymać Kartę Podarunkową teraz?",
        az: "Necə endirim əldə etmək olar",
    },
    tiw__howYouRateDevice__pickup_only_info: {
        key: "tiw__howYouRateDevice__pickup_only_info",
        ru: "Пожалуйста, учтите, что оцениваемое устройство нужно будет принести на точку выдачи заказа. Доставка заказа курьером будет недоступна.",
        en: "Please note that the evaluated device has to be brought to the pickup point. Courier delivery will not be available.",
        kz: "Бағаланатын құрылғыны тапсырысты алу орнына алып келу қажет екенін ескеріңіз. Тапсырысты курьер арқылы жеткізу қолжетімсіз болады.",
        ua: "Будь ласка, врахуйте, що пристрій, який оцінюється, потрібно буде принести на точку видачі замовлення. Доставка замовлення кур'єром буде недоступною.",
        pl: "Proszę pamiętać, że urządzenie podlegające ocenie będzie musiało zostać dostarczone do punktu odbioru zamówienia. Dostawa zamówienia kurierem nie będzie dostępna.",
        az: "Zəhmət olmasa, nəzərə alın ki, qiymətləndiriləcək cihazı sifarişin verildiyi nöqtəyə gətirmək lazım olacaq. Sifarişin kuryer ilə çatdırılması mümkün olmayacaq.",
    },
    tiw__howYouRateDevice__howGetSale_info_goShop: {
        key: "tiw__howYouRateDevice__howGetSale_info_goShop",
        ru: "Чтобы воспользоваться скидкой и сдать свое устройство в Trade-In, необходимо прийти в магазин. Устройство будет оценено на месте, после чего вам предоставят скидку на новую покупку.",
        en: "To take advantage of the discount and hand over your device to the Trade-In, you need to come to the store. The device will be evaluated on the spot, after which you will be given a discount on a new purchase.",
        kz: "Жеңілдікті пайдалану және құрылғыны Trade-In-ге өткізу үшін дүкенге келу керек. Құрылғы сол жерде бағаланады, содан кейін сізге жаңа сатып алуға жеңілдік беріледі.",
        ua: "Щоб скористатися вигодою та здати свій пристрій у Trade-In, необхідно прийти до магазину. Пристрій буде оцінено на місці, після чого ви сможете використати вигоду при купівлі нового пристрою",
        pl: "Aby skorzystać z rabatu i oddać urządzenie do odkupu, należy udać się do sklepu. Urządzenie zostanie wycenione na miejscu, po czym otrzymasz rabat na zakup nowego sprzętu.",
        az: "Endirimdən yararlanmaq və cihazınızı dəyişdirmək üçün mağazaya gəlməlisiniz. Cihaz yerində qiymətləndiriləcək, bundan sonra sizə yeni alışda endirim olunacaq.",
    },
    tiw__howYouRateDevice__warningNotification__minOrder: {
        key: "tiw__howYouRateDevice__warningNotification__minOrder",
        ru: "Обратите внимание, что цена сдаваемого устройства выше, чем цена покупаемого. На цену нового устройства будет применена максимально возможная скидка.",
        en: "Please note that price of the trade-in device is higher than the price of purchased device. Maximum possible discount will be applied to the price of the new device.",
        kz: "Жалға берілетін құрылғының бағасы сатып алынатын құрылғының бағасынан жоғары екеніне назар аударыңыз. Жаңа құрылғының бағасына мүмкін болатын ең жоғары жеңілдік қолданылады.",
        ua: "Зверніть увагу, що розмір вигоди за Trade-in не може бути більшим, ніж 99% ціни нового пристрою",
        pl: "Należy pamiętać, że wartość odkupionego urządzenia jest wyższa niż cena zakupionego urządzenia. Maksymalny możliwy rabat zostanie zastosowany do ceny nowego urządzenia.",
        az: "Nəzərə alın ki, geri qaytarılan cihazın qiyməti alınan cihazın qiymətindən yüksəkdir. Yeni cihazın qiymətinə maksimum mümkün endirim tətbiq olunacaq.",
    },
    tiw__enterImei__title: {
        key: "tiw__enterImei__title",
        ru: "Введите IMEI сдаваемого устройства",
        en: "Enter the IMEI of the device you are handing over",
        kz: "Өткізілетін құрылғының IMEI енгізіңіз",
        ua: "Введіть IMEI пристрою, що здається",
        pl: "Podaj numer IMEI urządzenia // Wpisz numer IMEI Twojego urządzenia ",
        az: "Alış cihazın IMEI-ni daxil edin",
    },
    tiw__enterImei__imei: {
        key: "tiw__enterImei__imei",
        ru: "IMEI",
        en: "IMEI",
        kz: "IMEI",
        ua: "IMEI",
        pl: "IMEI",
        az: "IMEI",
    },
    tiw__enterImei__status: {
        key: "tiw__enterImei__status",
        ru: "Идет проверка IMEI, до 60 секунд ожидания...",
        en: "The IMEI is being checked, up to 60 seconds of waiting...",
        kz: "IMEI тексерісі 60 секундқа дейін күтіледі...",
        ua: "Триває перевірка IMEI, до 60 секунд очікування...",
        pl: "Sprawdzamy numer IMEI. To zajmie chwilę (do 60 sekund).",
        az: "IMEI yoxlanışı davam edir, 60 saniyəyə qədər gözləmə...",
    },
    tiw__enterImei__imei_notAccepted: {
        key: "tiw__enterImei__imei_notAccepted",
        ru: "К сожалению данное устройство не принимается",
        en: "Unfortunately, this device is not accepted",
        kz: "Бұл құрылғыны қабылдауға жатпайды",
        ua: "На жаль, цей пристрій не приймається",
        pl: "Niestety, nie możemy zaakceptować tego urządzenia",
        az: "Təəssüf ki, bu cihaz qəbul edilmir.",
    },
    tiw__enterImei__imei_uncorrect: {
        key: "tiw__enterImei__imei_uncorrect",
        ru: "Проверьте правильность ввода IMEI",
        en: "Check that the IMEI is entered correctly",
        kz: "IMEI енгізуінің дұрыстығын тексеріңіз",
        ua: "Перевірте правильність введення IMEI",
        pl: "Sprawdź, czy IMEI został wprowadzony poprawnie",
        az: "IMEI-nin düzgün daxil olub-olmadığını yoxlayın",
    },
    tiw__enterImei__imei_reEvaluate: {
        key: "tiw__enterImei__imei_reEvaluate",
        ru: "Пожалуйста, перепройдите оценку, выбрав правильную модель",
        en: "Please re-evaluate by choosing the correct model",
        kz: "Дұрыс үлгіні таңдау арқылы бағалауды қайталаңыз",
        ua: "Будь ласка, перепройдіть оцінку, вибравши правильну модель",
        pl: "Sprawdź ponownie, wybierając prawidłowy model",
        az: "Düzgün modeli seçərək yenidən qiymətləndirin.",
    },
    tiw__enterImei__imei_foundSignedContract_title: {
        key: "tiw__enterImei__imei_foundSignedContract_title",
        ru: "Это устройство уже было оценено",
        en: "This device has already been rated",
        kz: "Бұл құрылғы қазірдің өзінде бағаланды",
        ua: "Цей пристрій вже було оцінено",
        pl: "To urządzenie było już wycenione",
        az: "Bu cihaz artıq qiymətləndirilib",
    },
    tiw__enterImei__imei_foundSignedContract_text: {
        key: "tiw__enterImei__imei_foundSignedContract_text",
        ru: 'Это устройство уже было оценено на <span class="tiw_fw-700">[[PRICE]] [[CURRENCY]]</span>. Применить эту же оценку?',
        en: 'This device has already been rated at <span class="tiw_fw-700">[[PRICE]] [[CURRENCY]]</span>. Apply the same rating?',
        kz: 'Бұл құрылғы қазірдің өзінде <span class="tiw_fw-700">[[PRICE]] [[CURRENCY]]</span> бағаланды. Осы бағалауды қолдану керек пе?',
        ua: 'Цей пристрій вже був оцінений на <span class="tiw_fw-700">[[PRICE]] [[CURRENCY]]</span>. Застосувати цю оцінку?',
        pl: 'Ostatnia wycena wynosiła <span class="tiw_fw-700">[[PRICE]] [[CURRENCY]]</span>. Czy chcesz z niej skorzystać, czy wycenić urządzenie ponownie?',
        az: 'Bu cihaz artıq <span class="tiw_fw-700">[[PRICE]] [[CURRENCY]]</span> səviyyəsində qiymətləndirilib. Eyni qiymətləndirmə tətbiq olunur?',
    },
    tiw__step__enterImei__warn__deviceTerminated: {
        key: "tiw__step__enterImei__warn__deviceTerminated",
        ru: "Устройство уже было оценено ранее и добавлено к заказу. Повторная оценка не может быть произведена.",
        en: "The device has already been evaluated earlier and added to the order. Re-evaluation can not be made.",
        kz: "Құрылғы бұрын бағаланған және тапсырысқа қосылған. Қайта бағалау мүмкін емес.",
        ua: "Пристрій було оцінено раніше і додано до замовлення. Повторна оцінка не може бути проведена.",
        pl: "Urządzenie zostało już wcześniej wycenione i dodane do zamówienia. Nie można dokonać ponownej wyceny.",
        az: "Cihaz artıq əvvəllər qiymətləndirilib və sifarişə əlavə edilib. Yenidən qiymətləndirmə aparıla bilməz.",
    },
    tiw__enterImei__imei_foundSignedContract_re_evaluate: {
        key: "tiw__enterImei__imei_foundSignedContract_re_evaluate",
        ru: "Оценить заново",
        en: "Re-evaluate",
        kz: "Қайта бағалау",
        ua: "Оцінити заново",
        pl: "Wyceń ponownie",
        az: "Yenidən qiymətləndirin",
    },
    tiw__enterImei__imei_foundSignedContract_apply_evaluate: {
        key: "tiw__enterImei__imei_foundSignedContract_apply_evaluate",
        ru: "Применить",
        en: "Apply",
        kz: "Қолдану",
        ua: "Застосувати",
        pl: "Użyj tej wyceny",
        az: "Tətbiq elə",
    },
    tiw__enterImei__yourModel: {
        key: "tiw__enterImei__yourModel",
        ru: "Модель вашего устройства",
        en: "The model of your device",
        kz: "Құрылғының моделі",
        ua: "Модель вашого пристрою",
        pl: "Model urządzenia",
        az: "Cihazınızın modeli",
    },
    tiw__enterImei__howFindImei: {
        key: "tiw__enterImei__howFindImei",
        ru: "Как найти IMEI?",
        en: "How do I find the IMEI?",
        kz: "IMEI қалай табуға болады?",
        ua: "Як знайти IMEI?",
        pl: "Jak znaleźć IMEI?",
        az: "IMEI-ni necə tapmaq olar?",
    },
    tiw__enterImei__howFindImei_step1: {
        key: "tiw__enterImei__howFindImei_step1",
        ru: "Наберите <strong>*#06#</strong> чтобы найти IMEI",
        en: "Dial <strong>*#06#</strong> to find the IMEI",
        kz: "IMEI табу үшін <strong>*#06#</strong> теріңіз",
        ua: "Наберіть <strong>*#06#</strong>, щоб знайти IMEI",
        pl: "Wpisz <strong>*#06#</strong> na klawiaturze telefonu.",
        az: "IMEI tapmaq üçün <strong>*#06#</strong> yığın",
    },
    tiw__enterImei__howFindImei_step2: {
        key: "tiw__enterImei__howFindImei_step2",
        ru: "Или найдите IMEI в настройках устройства",
        en: "Or find the IMEI in the device settings",
        kz: "Немесе құрылғы баптауларынан IMEI табыңыз",
        ua: "Або знайдіть IMEI у налаштуваннях пристрою",
        pl: "Otwórz ustawienia urządzenia (np. „Informacje o telefonie”).",
        az: "Və ya cihaz parametrlərində IMEI tapın",
    },
    tiw__downloadPhotos__networkError: {
        key: "tiw__downloadPhotos__networkError",
        ru: "К сожалению, возникла проблема при загрузке фотографий. Пожалуйста, убедитесь, что используете стабильное Интернет-соединение и попробуйте загрузить их ещё раз.",
        en: "Unfortunately an issue has occurred while uploading the photos. Please make sure that you have a stable Internet connection and try again.",
        kz: "Өкінішке орай, суреттерді жүктеуде мәселе туындады. Тұрақты интернет байланысын пайдаланып жатқаныңызды тексеріп, қайтадан жүктеп көріңіз.",
        ua: "На жаль, виникла проблема при завантаженні фотографій. Будь ласка, переконайтесь, що використовуєте стабільне інтернет-з'єднання, і спробуйте завантажити їх знову.",
        pl: "Niestety wystąpił problem z przesyłaniem zdjęć. Proszę sprawdzić swoje połączenie internetowe i spróbować ponownie.",
        az: "Unfortunately an issue has occurred while uploading the photos. Please make sure that you have a stable Internet connection and try again.",
    },
    tiw__downloadPhotos__title: {
        key: "tiw__downloadPhotos__title",
        ru: "Загрузите фото сдаваемого устройства",
        en: "Upload photos of the trade-in device",
        kz: "Өткізілетін құрылғының фотосуретін жүктеңіз",
        ua: "Завантажте фото пристрою, що здається",
        pl: "Prześlij zdjęcia urządzenia",
        az: "Trade-in olunan cihazın şəklini yükləyin",
    },
    tiw__downloadPhotos__qrInfo: {
        key: "tiw__downloadPhotos__qrInfo",
        ru: "Используйте фотографии в формате <strong>JPG, HEIC, DNG</strong> или <strong>PNG</strong>.",
        en: "Use photos in the format of <strong>JPG, HEIC, DNG</strong> or <strong>PNG</strong>.",
        kz: "<strong>JPG, HEIC, DNG</strong> немесе <strong>PNG</strong> фотосуреттерін пайдаланыңыз.",
        ua: "Використовуйте фотографії у форматі <strong>JPG, HEIC, DNG</strong> або <strong>PNG</strong>.",
        pl: "Użyj zdjęć w formacie <strong>JPG, HEIC, DNG</strong> lub <strong>PNG</strong>.",
        az: "<strong>JPG, HEIC, DNG</strong> və ya <strong>PNG</strong> formatında fotolardan istifadə edin.",
    },
    tiw__operatorExecuting__title_loading: {
        key: "tiw__operatorExecuting__title_loading",
        ru: "Подготовка к обработке",
        en: "Preparation for processing",
        kz: "Өңдеуге дайындық",
        ua: "Підготовка до обробки",
        pl: "Przygotowujemy analizę zdjęć",
        az: "Emal üçün hazırlıq",
    },
    tiw__operatorExecuting__message_loading: {
        key: "tiw__operatorExecuting__message_loading",
        ru: "Фотографии загружены, скоро начнётся оценка",
        en: "The photos have been uploaded, the evaluation will begin soon",
        kz: "Фотосуреттер жүктелді, енді бағалау басталады",
        ua: "Фотографії завантажені, незабаром почнеться оцінка",
        pl: "Zdjęcia zostały przesłane. Za chwilę rozpoczniemy ocenę urządzenia.",
        az: "Fotolar yüklənib, giymətləndirmə tezliklə başlayacaq",
    },
    tiw__operatorExecuting__title_processing: {
        key: "tiw__operatorExecuting__title_processing",
        ru: "Идет изучение фотографий",
        en: "Photos are being studied",
        kz: "Фотосуреттерді зерттеу жүріп жатыр",
        ua: "Йде вивчення фотографій",
        pl: "Analizujemy zdjęcia urządzenia",
        az: "Fotolar araşdırılır",
    },
    tiw__operatorExecuting__message_processing: {
        key: "tiw__operatorExecuting__message_processing",
        ru: "Оценка в процессе, пожалуйста, подождите 2-3 минуты",
        en: "Evaluation is in progress, please wait 2-3 minutes",
        kz: "Бағалау жүріп жатыр, 2-3 минут күтіңіз",
        ua: "Оцінка в процесі, будь ласка, зачекайте 2-3 хвилини",
        pl: "To potrwa około 2-3 minuty",
        az: "Qiymətləndirmə aparılır, lütfən, 2-3 dəqiqə gözləyin",
    },
    tiw__operatorExecuting__title_done: {
        key: "tiw__operatorExecuting__title_done",
        ru: "Все фото обработаны",
        en: "All photos have been processed",
        kz: "Барлық фотосуреттер өңделді",
        ua: "Усі фото оброблені",
        pl: "Kończymy analizę zdjęć",
        az: "Bütün fotolar işlənib",
    },
    tiw__operatorExecuting__message_done: {
        key: "tiw__operatorExecuting__message_done",
        ru: "Все фотографии были оценены, результат появится в течение 30 секунд",
        en: "All photos have been evaluated, the result will appear within 30 seconds",
        kz: "Барлық фотосуреттер өңделеді, нәтиже 30 секунд ішінде пайда болады",
        ua: "Усі фотографії були оцінені, результат з'явиться протягом 30 секунд",
        pl: "Za chwilę zobaczysz wynik oceny.",
        az: "Bütün fotoşəkillər qiymətləndirilib, nəticə 30 saniyə ərzində görünəcək",
    },
    tiw__operatorExecuting__sorryText: {
        key: "tiw__operatorExecuting__sorryText",
        ru: "К сожалению, оценка устройства потребовала больше времени, чем ожидалось. Приносим извинения за возникшие неудобства. Пожалуйста, не закрывайте окно и подождите ещё немного - результат вот-вот появится на экране",
        en: "Unfortunately, the evaluation of the device took longer than expected. We apologize for any inconvenience. Please do not close the window and wait a little longer - the result is about to appear on the screen",
        kz: "Өкінішке орай, құрылғыны бағалау күткеннен көп уақытты алды. Туындаған қолайсыздықтар үшін кешірім сұраймыз. Терезені жаппаңыз және тағы біраз күтіңіз - нәтиже экранда пайда болады",
        ua: "На жаль, оцінка пристрою потребує більше часу, ніж очікувалося. Просимо вибачення за незручності, що виникли. Будь ласка, не закривайте вікно і зачекайте ще трохи – результат ось-ось з'явиться на екрані",
        pl: "Niestety ocena urządzenia trwała dłużej niż oczekiwano. Przepraszamy za wszelkie niedogodności. Nie zamykaj okna i poczekaj trochę dłużej - wynik wkrótce pojawi się na ekranie.",
        az: "Təəssüf ki, cihazın qiymətləndirilməsi gözləniləndən daha uzun çəkdi. Bunun səbəb ola biləcəyi hər hansı narahatlığa görə üzr istəyirik. Pəncərəni bağlamayın və bir az daha gözləyin - nəticə tezliklə ekranda görünəcək",
    },
    tiw__evaluationResult__title: {
        key: "tiw__evaluationResult__title",
        ru: "Результат оценки",
        en: "Evaluation result",
        kz: "Бағалау нәтижесі",
        ua: "Результат оцінки",
        pl: "Wynik oceny",
        az: "Qiymətləndirmə nəticəsi",
    },
    tiw__evaluationResult__downloadMore: {
        key: "tiw__evaluationResult__downloadMore",
        ru: "Дозагрузить фото",
        en: "Upload more photos",
        kz: "Фотоларды қосымша жүктеу",
        ua: "Дозавантажити фото",
        pl: "Prześlij więcej zdjęć",
        az: "Foto yükləyin",
    },
    tiw__successfulEvaluation__title: {
        key: "tiw__successfulEvaluation__title",
        ru: "Время узнать цену!",
        en: "It's time to find out the price!",
        kz: "Бағаны білуге уақыт келді!",
        ua: "Час дізнатися ціну!",
        pl: "Czas poznać cenę!",
        az: "Qiyməti öyrənmək vaxtıdır!",
    },
    tiw__successfulEvaluation__subtitle: {
        key: "tiw__successfulEvaluation__subtitle",
        ru: "Теперь вы точно знаете, сколько сэкономите в Trade-In. Осталось подписать договор",
        en: "Now you know exactly how much you will save in Trade-In. It remains to sign an agreement",
        kz: "Енді сіз Trade-In-де қанша үнемдейтіндігіңізді білесіз. шартқа қол қою қалды",
        ua: "Тепер ви точно знаєте, скільки заощадите у Trade-In. Залишилось підписати договір",
        pl: "Teraz wiesz dokładnie, ile zaoszczędzisz na wymianie. Pozostaje podpisać umowę",
        az: "İndi siz Trade-In-də nə qədər qənaət edəcəyinizi dəqiq bilirsiniz. Sadəcə SMS müqaviləsini imzalamaq qalır",
    },
    tiw__successfulEvaluation__imei_title: {
        key: "tiw__successfulEvaluation__imei_title",
        ru: "IMEI вашего устройства",
        en: "IMEI of your device",
        kz: "Құрылғының IMEI",
        ua: "IMEI вашого пристрою",
        pl: "IMEI Twojego urządzenia",
        az: "Cihazınızın IMEI",
    },
    tiw__successfulEvaluation__imei: {
        key: "tiw__successfulEvaluation__imei",
        ru: "IMEI",
        en: "IMEI",
        kz: "IMEI",
        ua: "IMEI",
        pl: "IMEI",
        az: "IMEI",
    },
    tiw__successfulEvaluation__fio_title: {
        key: "tiw__successfulEvaluation__fio_title",
        ru: "Данные для заключения договора",
        en: "Data for the conclusion of the contract",
        kz: "Шарт жасауға арналған деректер",
        ua: "Дані для укладання договору",
        pl: "Dane do zawarcia umowy",
        az: "Müqavilə bağlamaq üçün məlumatlar",
    },
    tiw__successfulEvaluation__fio: {
        key: "tiw__successfulEvaluation__fio",
        ru: "ФИО",
        en: "Full name",
        kz: "ТАӘ",
        ua: "ПІБ",
        pl: "Pełna nazwa",
        az: "SAA",
    },
    "tiw__successfulEvaluation__fio_location-za": {
        key: "tiw__successfulEvaluation__fio_location-za",
        ru: "Full name",
        en: "Full name",
        kz: "Full name",
        ua: "Full name",
        pl: "Full name",
        az: "Full name",
    },
    tiw__successfulEvaluation__inn: {
        key: "tiw__successfulEvaluation__inn",
        ru: "Идентификационный номер (ИНН)",
        en: "Identification number (INN)",
        kz: "Сәйкестендіру нөмірі (ЖСН) ",
        ua: "Ідентифікаційний номер (ІПН)",
        pl: "Numer identyfikacyjny (INN)",
        az: "Eyniləşdirmə nömrəsi (VÖEN)",
    },
    tiw__successfulEvaluation__id_number: {
        key: "tiw__successfulEvaluation__id_number",
        ru: "ID Number",
        en: "ID Number",
        kz: "ID Number",
        ua: "ID Number",
        pl: "ID Number",
        az: "ID Number",
    },
    tiw__successfulEvaluation__passportSeriesNumber: {
        key: "tiw__successfulEvaluation__passportSeriesNumber",
        ru: "Серия и номер паспорта",
        en: "Passport series and number",
        kz: "Passport series and number",
        ua: "Серія та номер паспорта",
        pl: "Passport series and number",
        az: "Passport series and number",
    },
    tiw__successfulEvaluation__passportIssueDate: {
        key: "tiw__successfulEvaluation__passportIssueDate",
        ru: "Дата выдачи",
        en: "Passport issue date",
        kz: "Passport issue date",
        ua: "Дата видачі",
        pl: "Passport issue date",
        az: "Passport issue date",
    },
    tiw__successfulEvaluation__email: {
        key: "tiw__successfulEvaluation__email",
        ru: "Email",
        en: "Email",
        kz: "Email",
        ua: "Email",
        pl: "E-mail",
        az: "Email",
    },
    tiw__successfulEvaluation__phone: {
        key: "tiw__successfulEvaluation__phone",
        ru: "Телефон",
        en: "Phone",
        kz: "Телефон",
        ua: "Телефон",
        pl: "Telefon",
        az: "Telefon",
    },
    tiw__successfulEvaluation__checkbox_personal: {
        key: "tiw__successfulEvaluation__checkbox_personal",
        ru: 'Я соглашаюсь на обработку моих <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf"> персональных данных </a> и <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf"> условия Trade-In </a>',
        en: 'I agree to the processing of my <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf"> personal data </a> and <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf"> Trade-In terms </a>',
        kz: 'Мен <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf"> жеке деректерімді </a> және <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf"> cауда шарттары</a>',
        ua: 'Я погоджуюсь на обробку моїх <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf"> персональних даних </a> та <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf">умови Trade-In</a>',
        pl: 'Wyrażam zgodę na przetwarzanie moich <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf"> danych osobowych </a> i akceptuję <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf"> Regulamin. </a>',
        az: 'Mən <a class="tiw__link tiw__link_theme-light" target="blank" href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf"> şəxsi məlumatlarımın </a> və <a class="tiw__link tiw__link_theme-light" target="blank" href="-band" target="blank" href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" -in emalı ilə razıyam. </a>',
    },
    tiw__successfulEvaluation__checkbox_duty_head: {
        key: "tiw__successfulEvaluation__checkbox_duty_head",
        ru: "Я обязуюсь",
        en: "I commit to",
        kz: "Мен міндеттеймін",
        ua: "Я зобов'язуюсь",
        pl: "Zobowiązuję się do",
        az: "öhdəsinə götürürəm",
    },
    tiw__successfulEvaluation__checkbox_duty_step1: {
        key: "tiw__successfulEvaluation__checkbox_duty_step1",
        ru: "передать устройство с тем же IMEI, который был указан при оценке;",
        en: "transfer the device with the same IMEI that was specified during the evaluation;",
        kz: "құрылғыны бағалау кезінде көрсетілген бірдей IMEI-мен тапсыру;",
        ua: "передати пристрій з тим самим IMEI, який був вказаний при оцінці;",
        pl: "przekazania urządzenia z tym samym IMEI, który został podany podczas oceny;",
        az: "cihazı qiymətləndirmə zamanı göstərilən eyni IMEI ilə köçürün;",
    },
    tiw__successfulEvaluation__checkbox_duty_step2: {
        key: "tiw__successfulEvaluation__checkbox_duty_step2",
        ru: "передать устройство в том же состоянии, в каком оно было в момент диагностики;",
        en: "transfer the device in the same state as it was at the time of diagnosis;",
        kz: "құрылғыны диагностика кезінде болған күйінде тапсыру;",
        ua: "передати пристрій у тому стані, в якому він був в момент діагностики;",
        pl: "przekazania urządzenia w takim samym stanie, w jakim było w momencie diagnozy;",
        az: "cihazı diaqnostika zamanı olduğu vəziyyətdə təhvil verin;",
    },
    tiw__successfulEvaluation__checkbox_duty_step3: {
        key: "tiw__successfulEvaluation__checkbox_duty_step3",
        ru: "выйти из всех аккаунтов к моменту передачи устройства.",
        en: "log out of all accounts by the time the device is transferred.",
        kz: "құрылғыны беру кезінде барлық тіркеулік жазбалардан шығу.",
        ua: "вийти з усіх облікових записів до моменту передачі пристрою.",
        pl: "wylogowania się ze wszystkich kont do momentu przekazania urządzenia.",
        az: "Cihazı təhvil verməzdən əvvəl bütün hesablardan çıxın.",
    },
    tiw__successfulEvaluation__checkbox_duty_footer: {
        key: "tiw__successfulEvaluation__checkbox_duty_footer",
        ru: "Я понимаю, что невыполнение данных условий ведет к аннулированию покупки в Trade-In",
        en: "I understand that failure to comply with these conditions leads to the cancellation of the purchase in the Trade-In",
        kz: "Мен бұл шарттарды орындамау Trade-In сатып алудан бас тартуға әкелетінін түсінемін",
        ua: "Я розумію, що невиконання даних умов веде до анулювання покупки у Trade-In",
        pl: "Rozumiem, że niewykonanie tych warunków prowadzi do anulowania zakupu w programie Trade-In.",
        az: "Mən başa düşürəm ki, bu şərtlərə əməl edilməməsi Trade-In alışının ləğvi ilə nəticələnəcək.",
    },
    tiw__successfulEvaluation__warn: {
        key: "tiw__successfulEvaluation__warn",
        ru: "<strong>Обратите внимание!</strong> Получение заказа только по удостоверению личности.",
        en: "<strong>Please note!</strong> Receiving an order only with an identity card.",
        kz: "<strong>Назар аударыңыз!</strong> Тапсырысты тек жеке куәлік бойынша ала аласыз.",
        ua: "<strong>Зверніть увагу!</strong> Отримання замовлення лише за посвідченням особи.",
        pl: "<strong>Uwaga! </strong> Otrzymanie zamówienia tylko z dowodem tożsamości.",
        az: "<strong>Qeyd edin!</strong> Sifarişin qəbulu yalnız şəxsiyyət vəsiqəsi ilə mümkündür.",
    },
    tiw__successfulEvaluation__toContract: {
        key: "tiw__successfulEvaluation__toContract",
        ru: "Получить договор по SMS",
        en: "Get a contract by SMS",
        kz: "SMS арқылы шарт алу",
        ua: "Отримати договір по SMS",
        pl: "Otrzymanie umowy przez SMS",
        az: "SMS vasitəsilə müqavilə alın",
    },
    tiw__successfulEvaluation__addToCart: {
        key: "tiw__successfulEvaluation__addToCart",
        ru: "Добавить в корзину",
        en: "Add to Cart",
        kz: "Себетке қосу",
        ua: "Додати до кошику",
        pl: "Dodaj do koszyka",
        az: "Add to Cart",
    },
    tiw__successfulEvaluation__continue: {
        key: "tiw__successfulEvaluation__continue",
        ru: "Продолжить",
        en: "Continue",
        kz: "Жалғастыру",
        ua: "Продовжити",
        pl: "Kontynuuj",
        az: "Continue",
    },
    tiw__sendSmsContract__title: {
        key: "tiw__sendSmsContract__title",
        ru: "Осталось только подписать договор",
        en: "All that remains is to sign the contract",
        kz: "Шартқа қол қою ғана қалды",
        ua: "Залишилось лише підписати договір",
        pl: "Podpisz umowę",
        az: "Yalnız müqaviləni imzalamaq qalır",
    },
    tiw__sendSmsContract__subtitle: {
        key: "tiw__sendSmsContract__subtitle",
        ru: 'Договор успешно оформлен и ожидает подписания через SMS-сообщение. Для этого нажмите кнопку "Отправить SMS-договор"',
        en: 'The contract has been successfully executed and is awaiting signing via SMS. To do this, click the "Send SMS agreement" button',
        kz: 'Шарт сәтті ресімделді және SMS хабарлама арқылы қол қоюды күтуде. Ол үшін "SMS-шарт жіберу" батырмасын басыңыз',
        ua: 'Договір успішно оформлений та чекає на підписання через SMS-повідомлення. Для цього натисніть кнопку "Надіслати SMS-договір"',
        pl: 'Umowa została pomyślnie zrealizowana i oczekuje na podpisanie za pośrednictwem wiadomości SMS. Aby to zrobić, kliknij przycisk "Wyślij umowę SMS"',
        az: 'Müqavilə uğurla tamamlandı və SMS mesajı vasitəsilə imzalanmanı gözləyir. Bunu etmək üçün "SMS müqaviləsi göndər" düyməsini basın',
    },
    tiw__sendSmsContract__sendContract: {
        key: "tiw__sendSmsContract__sendContract",
        ru: "Отправить SMS-договор",
        en: "Send an SMS contract",
        kz: "SMS-шартты жіберу",
        ua: "Надіслати SMS-договір",
        pl: "Wyślij umowę SMS",
        az: "SMS müqavilə göndərin",
    },
    tiw__addToCart__title: {
        key: "tiw__addToCart__title",
        ru: "Ура! Все готово!",
        en: "Hurray! Everything is ready!",
        kz: "Алақай! Барлығы дайын!",
        ua: "Ура! Все готово!",
        pl: "Podpisz umowę",
        az: "Yaşasın! Hər şey hazırdır!",
    },
    tiw__addToCart__subtitle: {
        key: "tiw__addToCart__subtitle",
        ru: 'The agreement has been successfully sent to the number <strong>[[NUMBER]]</strong> and is awaiting signature via SMS. By clicking the "Continue" button, you confirm that you have signed the agreement.',
        en: 'The agreement has been successfully sent to the number <strong>[[NUMBER]]</strong> and is awaiting signature via SMS. By clicking the "Continue" button, you confirm that you have signed the agreement.',
        kz: 'The agreement has been successfully sent to the number <strong>[[NUMBER]]</strong> and is awaiting signature via SMS. By clicking the "Continue" button, you confirm that you have signed the agreement.',
        ua: 'The agreement has been successfully sent to the number <strong>[[NUMBER]]</strong> and is awaiting signature via SMS. By clicking the "Continue" button, you confirm that you have signed the agreement.',
        pl: "Wysłaliśmy umowę SMS-em na numer <strong>[[NUMBER]]</strong> i podpisz umowę. Po podpisaniu umowy przejdź dalej.",
        az: 'The agreement has been successfully sent to the number <strong>[[NUMBER]]</strong> and is awaiting signature via SMS. By clicking the "Continue" button, you confirm that you have signed the agreement.',
    },
    tiw__addToCart__notContract: {
        key: "tiw__addToCart__notContract",
        ru: "Не получили договор? Отправьте договор еще раз",
        en: "Have you not received the contract? Send the contract again",
        kz: "Шартты алмадыңыз ба? Шартты тағы бір рет жіберіңіз",
        ua: "Не отримали договір? Надішліть договір ще раз",
        pl: "SMS z umową nie dotarł do Ciebie?",
        az: "Müqaviləni almadınız? Zəhmət olmasa müqaviləni yenidən göndərin.",
    },
    tiw__addToCart__sendAgain: {
        key: "tiw__addToCart__sendAgain",
        ru: "Отправить SMS-договор еще раз",
        en: "Send the SMS contract again",
        kz: "SMS-шартын тағы бір рет жіберу",
        ua: "Надіслати SMS-договір ще раз",
        pl: "Wyślij umowę ponownie",
        az: "Yenidən SMS müqaviləsi göndərin",
    },
    tiw__addToCart__warn: {
        key: "tiw__addToCart__warn",
        ru: "Договор не был подписан",
        en: "The contract was not signed",
        kz: "Шартқа қол қойылмаған",
        ua: "Договір не був підписаний",
        pl: "Umowa nie została podpisana",
        az: "Müqavilə imzalanmayıb",
    },
    tiw__addToCart__addToCart: {
        key: "tiw__addToCart__addToCart",
        ru: "Добавить в корзину",
        en: "Add to Cart",
        kz: "Себетке қосу",
        ua: "Додати до кошику",
        pl: "Dodaj do koszyka",
        az: "Səbətə əlavə et",
    },
    tiw__signingWithoutSms__title: {
        key: "tiw__signingWithoutSms__title",
        ru: "Ура! Все готово!",
        en: "Hurray! Everything is ready!",
        kz: "Алақай! Барлығы дайын!",
        ua: "Ура! Все готово!",
        pl: "Podpisz umowę",
        az: "Yaşasın! Hər şey hazırdır!",
    },
    tiw__signingWithoutSms__subtitle: {
        key: "tiw__signingWithoutSms__subtitle",
        ru: "Договор успешно оформлен. Вам предоставят его на подписание, когда вы будете получать товар в магазине",
        en: "The contract has been successfully completed. You will be given it to sign when you receive the device in the store.",
        kz: "The contract has been successfully completed. You will be given it to sign when you receive the device in the store.",
        ua: "Договір успішно оформлено. Вам нададуть його на підписання, коли ви будете отримувати товар у магазині",
        pl: "Umowa została pomyślnie zrealizowana. Otrzymasz ją do podpisu po otrzymaniu produktu w sklepie.",
        az: "Müqavilə uğurla başa çatıb. Mağazada mal aldığınız zaman sizə imza atılacaq.",
    },
    tiw__signingWithoutSms__downloadContract: {
        key: "tiw__signingWithoutSms__downloadContract",
        ru: "Скачать договор",
        en: "Download the contract",
        kz: "Download the contract",
        ua: "Скачати договір",
        pl: "Pobierz umowę",
        az: "Müqaviləni yükləyin",
    },
    tiw__signingWithoutSms__downloadContract__title: {
        key: "tiw__signingWithoutSms__downloadContract__title",
        ru: "Хотите ознакомиться с договором заранее?",
        en: "Would you like to review the contract in advance?",
        kz: "Would you like to review the contract in advance?",
        ua: "Бажаєте ознайомитись з договором заздалегідь?",
        pl: "Chcesz wcześniej zapoznać się z umową?",
        az: "Müqaviləni əvvəlcədən nəzərdən keçirmək istərdinizmi?",
    },
    tiw__signingWithoutSms__addToCart: {
        key: "tiw__signingWithoutSms__addToCart",
        ru: "Добавить в корзину",
        en: "Add to Cart",
        kz: "Себетке қосу",
        ua: "Додати до кошику",
        pl: "Dodaj do koszyka",
        az: "Səbətə əlavə et",
    },
    tiw__chooseSigningType__title: {
        key: "tiw__chooseSigningType__title",
        ru: "Осталось только подписать договор",
        en: "All that remains is to sign the contract",
        kz: "All that remains is to sign the contract",
        ua: "Залишилось лише підписати договір",
        pl: "Podpisz umowę",
        az: "Yalnız müqaviləni imzalamaq qalır",
    },
    tiw__chooseSigningType__text: {
        key: "tiw__chooseSigningType__text",
        ru: "Выберите способ подписания",
        en: "Select signing method",
        kz: "Select signing method",
        ua: "Виберіть спосіб підписання",
        pl: "Wybierz metodę podpisywania",
        az: "İmzalama üsulunu seçin",
    },
    tiw__chooseSigningType__signingType__trustmeKz__title: {
        key: "tiw__chooseSigningType__signingType__trustmeKz__title",
        ru: "Подписать договор по SMS",
        en: "Sign an agreement via SMS",
        kz: "Sign an agreement via SMS",
        ua: "Підписати договір по SMS",
        pl: "Podpisz umowę poprzez SMS",
        az: "Müqaviləni SMS vasitəsilə imzalayın",
    },
    tiw__chooseSigningType__signingType__trustmeKz__description: {
        key: "tiw__chooseSigningType__signingType__trustmeKz__description",
        ru: "Подпишите договор прямо сейчас, получив его на телефон и введя код подтвердждения. Это займёт 1-2 минуты и сэкономит время при получении товара",
        en: "Sign the contract right now by receiving it on your phone and entering the confirmation code. This will take 1-2 minutes and will save time when receiving device",
        kz: "Sign the contract right now by receiving it on your phone and entering the confirmation code. This will take 1-2 minutes and will save time when receiving device",
        ua: "Підпишіть договір прямо зараз, отримавши його на телефон та ввівши код підтвердження. Це займе 1-2 хвилини та заощадить час при отриманні товару",
        pl: "Podpisz umowę już teraz, odbierając ją na swój telefon i wpisując kod potwierdzający. Zajmie to 1-2 minuty i pozwoli zaoszczędzić czas przy odbiorze towaru",
        az: "Telefonunuza qəbul edərək və təsdiq kodunu daxil etməklə müqaviləni elə indi imzalayın. 1-2 dəqiqə çəkəcək və malları qəbul edərkən vaxta qənaət edəcək.",
    },
    tiw__chooseSigningType__signingType__scrive__title: {
        key: "tiw__chooseSigningType__signingType__scrive__title",
        ru: "Scrive title",
        en: "Scrive title",
        kz: "Scrive title",
        ua: "Scrive title",
        pl: "Scrive title",
        az: "Scrive title",
    },
    tiw__chooseSigningType__signingType__scrive__description: {
        key: "tiw__chooseSigningType__signingType__scrive__description",
        ru: "Scrive description",
        en: "Scrive description",
        kz: "Scrive description",
        ua: "Scrive description",
        pl: "Scrive description",
        az: "Scrive description",
    },
    tiw__chooseSigningType__signingType__withoutSms__title: {
        key: "tiw__chooseSigningType__signingType__withoutSms__title",
        ru: "Подписать договор при получении",
        en: "Sign the contract upon receipt",
        kz: "Sign the contract upon receipt",
        ua: "Підписати договір при отриманні",
        pl: "Podpisz umowę po otrzymaniu",
        az: "Müqaviləni aldıqdan sonra imzalayın",
    },
    tiw__chooseSigningType__signingType__withoutSms__description: {
        key: "tiw__chooseSigningType__signingType__withoutSms__description",
        ru: "Подпишите договор во время получения товара. Это ускорит оформление заказа сейчас",
        en: "Sign the contract when receiving device. This will speed up your order now.",
        kz: "Sign the contract when receiving device. This will speed up your order now.",
        ua: "Підпишіть договір під час отримання товару. Це прискорить оформлення замовлення зараз",
        pl: "Podpisz umowę przy odbiorze towaru. Przyspieszy to teraz Twoje zamówienie.",
        az: "Cihazını aldıqdan sonra müqaviləni imzalayın. Bu, indi sifarişinizi sürətləndirəcək.",
    },
    tiw__handedDevice__condition: {
        key: "tiw__handedDevice__condition",
        ru: "Condition",
        en: "Condition",
        kz: "Condition",
        ua: "Стан",
        pl: "Stan",
        az: "Condition",
    },
    tiw__handedDevice__valuation: {
        key: "tiw__handedDevice__valuation",
        ru: "Device valuation",
        en: "Device valuation",
        kz: "Device valuation",
        ua: "Оцінка пристрою",
        pl: "Wycena",
        az: "Device valuation",
    },
    tiw__methodToReceiveDiscount__title: {
        key: "tiw__methodToReceiveDiscount__title",
        ru: "Choose a method to receive a discount",
        en: "Choose a method to receive a discount",
        kz: "Choose a method to receive a discount",
        ua: "Виберіть спосіб отримання знижки",
        pl: "Wybierz, w jaki sposób chcesz otrzymać bon",
        az: "Choose a method to receive a discount",
    },
    tiw__methodToReceiveDiscount__getOnline__title: {
        key: "tiw__methodToReceiveDiscount__getOnline__title",
        ru: "Get a discount online now",
        en: "Get a discount online now",
        kz: "Get a discount online now",
        ua: "Отримайте знижку онлайн зараз",
        pl: "Odbierz bon online",
        az: "Get a discount online now",
    },
    tiw__methodToReceiveDiscount__getOnline__text: {
        key: "tiw__methodToReceiveDiscount__getOnline__text",
        ru: "Be ready to provide your credit card information to hold funds or complete biometric verification of your identity",
        en: "Be ready to provide your credit card information to hold funds or complete biometric verification of your identity",
        kz: "Be ready to provide your credit card information to hold funds or complete biometric verification of your identity",
        ua: "Be ready to provide your credit card information to hold funds or complete biometric verification of your identity",
        pl: "Wystarczy, że potwierdzisz, że Ty to Ty dowodem osobistym lub podasz swoją kartę płatniczą i od razu dostaniesz swój bon.",
        az: "Be ready to provide your credit card information to hold funds or complete biometric verification of your identity",
    },
    tiw__methodGetDiscountAfter__title: {
        key: "tiw__methodGetDiscountAfter__title",
        ru: "Get a discount in-store later",
        en: "Get a discount in-store later",
        kz: "Get a discount in-store later",
        ua: "Get a discount in-store later",
        pl: "Odbierz bon po przekazaniu urządzenia",
        az: "Get a discount in-store later",
    },
    tiw__methodGetDiscountAfter__text: {
        key: "tiw__methodGetDiscountAfter__text",
        ru: "Bring your device to a store and get a voucher to use toward your purchase. No credit card details or biometric verification needed.",
        en: "Bring your device to a store and get a voucher to use toward your purchase. No credit card details or biometric verification needed.",
        kz: "Bring your device to a store and get a voucher to use toward your purchase. No credit card details or biometric verification needed.",
        ua: "Bring your device to a store and get a voucher to use toward your purchase. No credit card details or biometric verification needed.",
        pl: "Oddaj smartfon w salonie. Po weryfikacji otrzymasz bon do wykorzystania na zakupy – bez podawania danych karty płatniczej i dodatkowych formalności.",
        az: "Bring your device to a store and get a voucher to use toward your purchase. No credit card details or biometric verification needed.",
    },
    tiw__modal__serviceProvide: {
        key: "tiw__modal__serviceProvide",
        ru: "The service provider for the buyback and the party to the agreement is Breezy Poland Sp. z o.o., Słowikowskiego 81 / Building H1, 05-090 Raszyn, KRS 0001001952",
        en: "The service provider for the buyback and the party to the agreement is Breezy Poland Sp. z o.o., Słowikowskiego 81 / Building H1, 05-090 Raszyn, KRS 0001001952",
        kz: "The service provider for the buyback and the party to the agreement is Breezy Poland Sp. z o.o., Słowikowskiego 81 / Building H1, 05-090 Raszyn, KRS 0001001952",
        ua: "The service provider for the buyback and the party to the agreement is Breezy Poland Sp. z o.o., Słowikowskiego 81 / Building H1, 05-090 Raszyn, KRS 0001001952",
        pl: "Usługodawcą w zakresie odkupu i stroną umowy jest Breezy Poland Sp. z o.o., Słowikowskiego 81 / Budynek H1, 05-090 Raszyn, KRS 0001001952",
        az: "The service provider for the buyback and the party to the agreement is Breezy Poland Sp. z o.o., Słowikowskiego 81 / Building H1, 05-090 Raszyn, KRS 0001001952",
    },
    tiw__discount__100: {
        key: "tiw__discount__100",
        ru: "Discount",
        en: "Discount",
        kz: "Discount",
        ua: "Discount",
        pl: "Rabat - 100% wyceny urządzenia",
        az: "Discount",
    },
    tiw__discount__70: {
        key: "tiw__discount__70",
        ru: "Discount",
        en: "Discount",
        kz: "Discount",
        ua: "Discount",
        pl: "Rabat - 70% wyceny urządzenia",
        az: "Discount",
    },
    tiw__getDiscount: {
        key: "tiw__getDiscount",
        ru: "Get a discount",
        en: "Get a discount",
        kz: "Get a discount",
        ua: "Get a discount",
        pl: "Odbierz bon",
        az: "Get a discount",
    },
    tiw__rangeDiscount__title: {
        key: "tiw__rangeDiscount__title",
        ru: "Choose the range of discount",
        en: "Choose the range of discount",
        kz: "Choose the range of discount",
        ua: "Choose the range of discount",
        pl: "Wybierz wartość bonu",
        az: "Choose the range of discount",
    },
    tiw__rangeDiscount__hold__text: {
        key: "tiw__rangeDiscount__hold__text",
        ru: "Hold of funds on the card",
        en: "Hold of funds on the card",
        kz: "Hold of funds on the card",
        ua: "Hold of funds on the card",
        pl: "Środki o równowartości bonu zostaną zablokowane na karcie płatniczej do momentu weryfikacji odesłanego urządzenia w Breezy Poland.",
        az: "Hold of funds on the card",
    },
    tiw__rangeDiscount__biometric__text: {
        key: "tiw__rangeDiscount__biometric__text",
        ru: "Biometric verification with the provision of documents for identity verification and signing a contract with the obligation to transfer the device to us within 14 days from the date of order placement",
        en: "Biometric verification with the provision of documents for identity verification and signing a contract with the obligation to transfer the device to us within 14 days from the date of order placement",
        kz: "Biometric verification with the provision of documents for identity verification and signing a contract with the obligation to transfer the device to us within 14 days from the date of order placement",
        ua: "Biometric verification with the provision of documents for identity verification and signing a contract with the obligation to transfer the device to us within 14 days from the date of order placement",
        pl: "Jeśli nie chcesz podawać numeru karty, to wycena urządzenia będzie niższa. Poprosimy Cię o dane do weryfikacji Twojej tożsamości, a bon płatniczy do Orange wykorzystasz od razu.",
        az: "Biometric verification with the provision of documents for identity verification and signing a contract with the obligation to transfer the device to us within 14 days from the date of order placement",
    },
    tiw__chooseDelivery__title: {
        key: "tiw__chooseDelivery__title",
        ru: "Choose the delivery method",
        en: "Choose the delivery method",
        kz: "Choose the delivery method",
        ua: "Choose the delivery method",
        pl: "Wybierz metodę dostawy",
        az: "Choose the delivery method",
    },
    tiw__chooseDelivery__courierDelivery__title: {
        key: "tiw__chooseDelivery__courierDelivery__title",
        ru: "Courier Delivery",
        en: "Courier Delivery",
        kz: "Courier Delivery",
        ua: "Courier Delivery",
        pl: "Dostawa kurierska",
        az: "Courier Delivery",
    },
    tiw__chooseDelivery__courierDelivery__text: {
        key: "tiw__chooseDelivery__courierDelivery__text",
        ru: "The device's compliance with the contract will be verified by the courier who collects the device from you. Upon successful verification, you will receive a discount.",
        en: "The device's compliance with the contract will be verified by the courier who collects the device from you. Upon successful verification, you will receive a discount.",
        kz: "The device's compliance with the contract will be verified by the courier who collects the device from you. Upon successful verification, you will receive a discount.",
        ua: "The device's compliance with the contract will be verified by the courier who collects the device from you. Upon successful verification, you will receive a discount.",
        pl: "Zgodność urządzenia z umową zostanie sprawdzona przez kuriera, który odbierze urządzenie od Ciebie. Po pomyślnym sprawdzeniu otrzymasz zniżkę.",
        az: "The device's compliance with the contract will be verified by the courier who collects the device from you. Upon successful verification, you will receive a discount.",
    },
    tiw__chooseDelivery__pickUp__title: {
        key: "tiw__chooseDelivery__pickUp__title",
        ru: "In-Store Pickup",
        en: "In-Store Pickup",
        kz: "In-Store Pickup",
        ua: "In-Store Pickup",
        pl: "Odbiór w sklepie",
        az: "In-Store Pickup",
    },
    tiw__chooseDelivery__pickUp__text: {
        key: "tiw__chooseDelivery__pickUp__text",
        ru: "After signing the contract online, take your phone to any Orange store. Upon successful verification, you will receive a discount.",
        en: "After signing the contract online, take your phone to any Orange store. Upon successful verification, you will receive a discount.",
        kz: "After signing the contract online, take your phone to any Orange store. Upon successful verification, you will receive a discount.",
        ua: "After signing the contract online, take your phone to any Orange store. Upon successful verification, you will receive a discount.",
        pl: "Po podpisaniu umowy online, zabierz swój telefon do dowolnego sklepu Orange. Po pomyślnej weryfikacji otrzymasz zniżkę.",
        az: "After signing the contract online, take your phone to any Orange store. Upon successful verification, you will receive a discount.",
    },
    tiw__creditCardPreAuthorization__title: {
        key: "tiw__creditCardPreAuthorization__title",
        ru: "Credit card pre-authorization",
        en: "Credit card pre-authorization",
        kz: "Credit card pre-authorization",
        ua: "Credit card pre-authorization",
        pl: "Uzupełnij dane karty płatniczej",
        az: "Credit card pre-authorization",
    },
    tiw__creditCardPreAuthorization__text: {
        key: "tiw__creditCardPreAuthorization__text",
        ru: "Please prepare your credit card and make sure it is valid and there are funds in the account corresponding to the price of the device. We also require to accept our Terms and conditions and agree to processing your personal data.",
        en: "Please prepare your credit card and make sure it is valid and there are funds in the account corresponding to the price of the device. We also require to accept our Terms and conditions and agree to processing your personal data.",
        kz: "Please prepare your credit card and make sure it is valid and there are funds in the account corresponding to the price of the device. We also require to accept our Terms and conditions and agree to processing your personal data.",
        ua: "Please prepare your credit card and make sure it is valid and there are funds in the account corresponding to the price of the device. We also require to accept our Terms and conditions and agree to processing your personal data.",
        pl: "Aby otrzymać Kartę Podarunkową jeszcze przed wysłaniem urządzenia, zablokujemy jej wartość na Twojej karcie płatniczej. To tylko tymczasowa blokada. Nie pobieramy środków. Przygotuj ważną kartę (debetową lub kredytową) i upewnij się, że masz na niej wystarczające środki. ",
        az: "Please prepare your credit card and make sure it is valid and there are funds in the account corresponding to the price of the device. We also require to accept our Terms and conditions and agree to processing your personal data.",
    },
    tiw__personAuthentication__title: {
        key: "tiw__personAuthentication__title",
        ru: "Authentication",
        en: "Authentication",
        kz: "Authentication",
        ua: "Authentication",
        pl: "Uwierzytelnianie",
        az: "Authentication",
    },
    tiw__personAuthentication__text: {
        key: "tiw__personAuthentication__text",
        ru: "Please prepare your identity document and make sure it is valid. We also require to accept our Terms and conditions and agree to processing your personal data.",
        en: "Please prepare your identity document and make sure it is valid. We also require to accept our Terms and conditions and agree to processing your personal data.",
        kz: "Please prepare your identity document and make sure it is valid. We also require to accept our Terms and conditions and agree to processing your personal data.",
        ua: "Please prepare your identity document and make sure it is valid. We also require to accept our Terms and conditions and agree to processing your personal data.",
        pl: "Prosimy o przygotowanie dokumentu tożsamości i upewnienie się, że jest on ważny. Wymagamy również zaakceptowania naszych Warunków użytkowania i wyrażenia zgody na przetwarzanie danych osobowych.",
        az: "Please prepare your identity document and make sure it is valid. We also require to accept our Terms and conditions and agree to processing your personal data.",
    },
    tiw__creditCardPreAuthorization__accepted: {
        key: "tiw__creditCardPreAuthorization__accepted",
        ru: 'I accept <a href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" target="_blank">Terms and Conditions</a>',
        en: 'I accept <a href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" target="_blank">Terms and Conditions</a>',
        kz: 'I accept <a href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" target="_blank">Terms and Conditions</a>',
        ua: 'I accept <a href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" target="_blank">Terms and Conditions</a>',
        pl: 'Akceptuję <a href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" target="_blank">Regulamin</a>',
        az: 'I accept <a href="https://cdn.new-brz.net/public/static/regulamin_odkupu_urzadzen.pdf" target="_blank">Terms and Conditions</a>',
    },
    tiw__creditCardPreAuthorization__agree: {
        key: "tiw__creditCardPreAuthorization__agree",
        ru: 'I agree to the processing of my personal data as described in the <a href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf" target="_blank"> Consent to Personal Data Processing',
        en: 'I agree to the processing of my personal data as described in the <a href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf" target="_blank"> Consent to Personal Data Processing',
        kz: 'I agree to the processing of my personal data as described in the <a href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf" target="_blank"> Consent to Personal Data Processing',
        ua: 'I agree to the processing of my personal data as described in the <a href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf" target="_blank"> Consent to Personal Data Processing',
        pl: 'Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z <a href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf "target="_blank">Polityką przetwarzania danych</a>',
        az: 'I agree to the processing of my personal data as described in the <a href="https://cdn.new-brz.net/public/static/przetwarzanie_danych_osobowcyh.pdf" target="_blank"> Consent to Personal Data Processing',
    },
    tiw__start: {
        key: "tiw__start",
        ru: "Start",
        en: "Start",
        kz: "Start",
        ua: "Start",
        pl: "Rozpocznij",
        az: "Start",
    },
    tiw__creditCardPreAuthorization__transactionComplete__success__title: {
        key: "tiw__creditCardPreAuthorization__transactionComplete__success__title",
        ru: "Transaction complete",
        en: "Transaction complete",
        kz: "Transaction complete",
        ua: "Transaction complete",
        pl: "Środki zostały zabezpieczone",
        az: "Transaction complete",
    },
    tiw__creditCardPreAuthorization__transactionComplete__success__text: {
        key: "tiw__creditCardPreAuthorization__transactionComplete__success__text",
        ru: "We managed to block an amount corresponding to the value of the device on your card",
        en: "We managed to block an amount corresponding to the value of the device on your card",
        kz: "We managed to block an amount corresponding to the value of the device on your card",
        ua: "We managed to block an amount corresponding to the value of the device on your card",
        pl: "Zablokowaliśmy kwotę odpowiadającą wartości urządzenia na Twojej karcie. Nie pobraliśmy środków.",
        az: "We managed to block an amount corresponding to the value of the device on your card",
    },
    tiw__creditCardPreAuthorization__transactionComplete__error__title: {
        key: "tiw__creditCardPreAuthorization__transactionComplete__error__title",
        ru: "Something gone wrong",
        en: "Something gone wrong",
        kz: "Something gone wrong",
        ua: "Something gone wrong",
        pl: "Nie udało się zabezpieczyć środków",
        az: "Something gone wrong",
    },
    tiw__creditCardPreAuthorization__transactionComplete__error__text: {
        key: "tiw__creditCardPreAuthorization__transactionComplete__error__text",
        ru: "Sorry, we can't complete your payment",
        en: "Sorry, we can't complete your payment",
        kz: "Sorry, we can't complete your payment",
        ua: "Sorry, we can't complete your payment",
        pl: "Nie mogliśmy zablokować środków na Twojej karcie.",
        az: "Sorry, we can't complete your payment",
    },
    tiw__personAuthentication__success__title: {
        key: "tiw__personAuthentication__success__title",
        ru: "Authentication Successful",
        en: "Authentication Successful",
        kz: "Authentication Successful",
        ua: "Authentication Successful",
        pl: "Weryfikacja zakończona pomyślnie",
        az: "Authentication Successful",
    },
    tiw__personAuthentication__success__text: {
        key: "tiw__personAuthentication__success__text",
        ru: "Your identity has been successfully verified",
        en: "Your identity has been successfully verified",
        kz: "Your identity has been successfully verified",
        ua: "Your identity has been successfully verified",
        pl: "Twoja tożsamość została pomyślnie zweryfikowana.",
        az: "Your identity has been successfully verified",
    },
    tiw__personAuthentication__error__title: {
        key: "tiw__personAuthentication__error__title",
        ru: "Authentication Failed",
        en: "Authentication Failed",
        kz: "Authentication Failed",
        ua: "Authentication Failed",
        pl: "Uwierzytelnianie nie powiodło się",
        az: "Authentication Failed",
    },
    tiw__personAuthentication__error__text: {
        key: "tiw__personAuthentication__error__text",
        ru: "Sorry, we are unable to verify your identity",
        en: "Sorry, we are unable to verify your identity",
        kz: "Sorry, we are unable to verify your identity",
        ua: "Sorry, we are unable to verify your identity",
        pl: "Przepraszamy, nie możemy zweryfikować Twojej tożsamości.",
        az: "Sorry, we are unable to verify your identity",
    },
    tiw__btn__completeDifferentWay: {
        key: "tiw__btn__completeDifferentWay",
        ru: "Complete in different way",
        en: "Complete in different way",
        kz: "Complete in different way",
        ua: "Complete in different way",
        pl: "Wypełnij w inny sposób",
        az: "Complete in different way",
    },
    tiw__btn__quit: {
        key: "tiw__btn__quit",
        ru: "quit",
        en: "quit",
        kz: "quit",
        ua: "quit",
        pl: "Wyjść",
        az: "quit",
    },
    tiw__weWillSendInstructions: {
        key: "tiw__weWillSendInstructions",
        ru: "We will send instructions on how to log out of your account and correctly transfer the device to this address",
        en: "We will send instructions on how to log out of your account and correctly transfer the device to this address",
        kz: "We will send instructions on how to log out of your account and correctly transfer the device to this address",
        ua: "We will send instructions on how to log out of your account and correctly transfer the device to this address",
        pl: "Na ten adres wyślemy instrukcje, jak wylogować się z konta i prawidłowo przekazać urządzenie.",
        az: "We will send instructions on how to log out of your account and correctly transfer the device to this address",
    },
    tiw__thanksYou__title: {
        key: "tiw__thanksYou__title",
        ru: "Thank you!",
        en: "Thank you!",
        kz: "Thank you!",
        ua: "Thank you!",
        pl: "Dziękujemy!",
        az: "Thank you!",
    },
    tiw__thanksYou__text: {
        key: "tiw__thanksYou__text",
        ru: "The contract has been signed correctly!",
        en: "The contract has been signed correctly!",
        kz: "The contract has been signed correctly!",
        ua: "The contract has been signed correctly!",
        pl: "Umowa podpisana - wybierz sposób przekazania urządzenia",
        az: "The contract has been signed correctly!",
    },
    tiw__thanksYou__pleaseProvide: {
        key: "tiw__thanksYou__pleaseProvide",
        ru: "Please provide the address from which the courier will pick up the phone.",
        en: "Please provide the address from which the courier will pick up the phone.",
        kz: "Please provide the address from which the courier will pick up the phone.",
        ua: "Please provide the address from which the courier will pick up the phone.",
        pl: "Podaj adres odbioru urządzenia",
        az: "Please provide the address from which the courier will pick up the phone.",
    },
    tiw__thanksYou_useTheSameAddress: {
        key: "tiw__thanksYou_useTheSameAddress",
        ru: "Use the same address from contract signing",
        en: "Use the same address from contract signing",
        kz: "Use the same address from contract signing",
        ua: "Use the same address from contract signing",
        pl: "Użyj tego samego adresu, który podałeś przy podpisywaniu umowy.",
        az: "Use the same address from contract signing",
    },
    tiw__thanksYou_pleaseSpecifyArrivalDate: {
        key: "tiw__thanksYou_pleaseSpecifyArrivalDate",
        ru: "Please specify the courier's arrival date",
        en: "Please specify the courier's arrival date",
        kz: "Please specify the courier's arrival date",
        ua: "Please specify the courier's arrival date",
        pl: "Wybierz datę odbioru przez kuriera",
        az: "Please specify the courier's arrival date",
    },
    tiw__voucherSent__title: {
        key: "tiw__voucherSent__title",
        ru: "Voucher sent",
        en: "Voucher sent",
        kz: "Voucher sent",
        ua: "Voucher sent",
        pl: "Bon wysłany",
        az: "Voucher sent",
    },
    tiw__voucherSent__title_withAdditionalCertificates: {
        key: "tiw__voucherSent__title_withAdditionalCertificates",
        ru: "Vouchers sent",
        en: "Vouchers sent",
        kz: "Vouchers sent",
        ua: "Vouchers sent",
        pl: "Bony wysłane",
        az: "Vouchers sent",
    },
    tiw__voucherSent__text: {
        key: "tiw__voucherSent__text",
        ru: 'According to the agreement, you receive an Orange Electronic Payment Voucher worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        en: 'According to the agreement, you receive an Orange Electronic Payment Voucher worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        kz: 'According to the agreement, you receive an Orange Electronic Payment Voucher worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        ua: 'According to the agreement, you receive an Orange Electronic Payment Voucher worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        pl: 'Zgodnie z umową otrzymujesz elektroniczny bon płatniczy Orange o wartości [[PRICE]] [[CURRENCY]], który możesz wykorzystać na stronie <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> lub w salonie Orange.',
        az: 'According to the agreement, you receive an Orange Electronic Payment Voucher worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
    },
    tiw__voucherSent__text_withAdditionalCertificates: {
        key: "tiw__voucherSent__text_withAdditionalCertificates",
        pl: 'Zgodnie z umową otrzymujesz elektroniczne bony płatniczy Orange o całkowitej wartości [[PRICE]] [[CURRENCY]], który możesz wykorzystać na stronie <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> lub w salonie Orange.',
        en: 'According to the agreement, you receive an Orange Electronic Payment Vouchers worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        ru: 'According to the agreement, you receive an Orange Electronic Payment Vouchers worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        kz: 'According to the agreement, you receive an Orange Electronic Payment Vouchers worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        ua: 'According to the agreement, you receive an Orange Electronic Payment Vouchers worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
        az: 'According to the agreement, you receive an Orange Electronic Payment Vouchers worth [[PRICE]] [[CURRENCY]] which you can use on <a class="tiw__step__voucherSent__header__link" href="https://www.orange.pl/esklep/smartfony?typ-oferty=VOICE&tylko-dostepne">orange.pl</a> or in an Orange showroom.',
    },
    tiw__voucherSent__whatNext__title: {
        key: "tiw__voucherSent__whatNext__title",
        ru: "What’s next?",
        en: "What’s next?",
        kz: "What’s next?",
        ua: "What’s next?",
        pl: "Co dalej?",
        az: "What’s next?",
    },
    tiw__voucherSent__whatNext__goToOrange: {
        key: "tiw__voucherSent__whatNext__goToOrange",
        ru: "Go to the Orange offer selection and add it to your cart,",
        en: "Go to the Orange offer selection and add it to your cart,",
        kz: "Go to the Orange offer selection and add it to your cart,",
        ua: "Go to the Orange offer selection and add it to your cart,",
        pl: "Przejdź do oferty Orange i dodaj ją do koszyka,",
        az: "Go to the Orange offer selection and add it to your cart,",
    },
    tiw__voucherSent__whatNext__enterVoucher: {
        key: "tiw__voucherSent__whatNext__enterVoucher",
        ru: "enter the code from the voucher you received,",
        en: "enter the code from the voucher you received,",
        kz: "enter the code from the voucher you received,",
        ua: "enter the code from the voucher you received,",
        pl: "Wprowadź kod z otrzymanego bonu,",
        az: "enter the code from the voucher you received,",
    },
    tiw__voucherSent__whatNext__enterVoucher_withAdditionalCertificates: {
        key: "tiw__voucherSent__whatNext__enterVoucher_withAdditionalCertificates",
        ru: "enter the code from the vouchers you received,",
        en: "enter the code from the vouchers you received,",
        kz: "enter the code from the vouchers you received,",
        ua: "enter the code from the vouchers you received,",
        pl: "Wprowadź kod z otrzymanych bonów,",
        az: "enter the code from the vouchers you received,",
    },
    tiw__voucherSent__whatNext__finalizeYourOrder: {
        key: "tiw__voucherSent__whatNext__finalizeYourOrder",
        ru: "Complete your order!",
        en: "Complete your order!",
        kz: "Complete your order!",
        ua: "Complete your order!",
        pl: "Sfinalizuj swoje zamówienie!",
        az: "Complete your order!",
    },
    tiw__voucherSent__whatNext__14days: {
        key: "tiw__voucherSent__whatNext__14days",
        ru: "Hand over your device to a courier or at an Orange store within 14 days",
        en: "Hand over your device to a courier or at an Orange store within 14 days",
        kz: "Hand over your device to a courier or at an Orange store within 14 days",
        ua: "Hand over your device to a courier or at an Orange store within 14 days",
        pl: "Przekaż swoje urządzenie kurierowi lub do dowolnego salonu Orange (w zależności od wybranej opcji) w ciągu 14 dni.",
        az: "Hand over your device to a courier or at an Orange store within 14 days",
    },
    tiw__voucherSent__whatNext__useVoucherNow: {
        key: "tiw__voucherSent__whatNext__useVoucherNow",
        ru: "Use voucher now",
        en: "Use voucher now",
        kz: "Use voucher now",
        ua: "Use voucher now",
        pl: "Wykorzystaj bon teraz",
        az: "Use voucher now",
    },
    tiw__voucherSent__whatNext__useVoucherNow_withAdditionalCertificates: {
        key: "tiw__voucherSent__whatNext__useVoucherNow_withAdditionalCertificates",
        ru: "Use vouchers now",
        en: "Use vouchers now",
        kz: "Use vouchers now",
        ua: "Use vouchers now",
        pl: "Wykorzystaj bony teraz",
        az: "Use vouchers now",
    },
    tiw__successfulEvaluation__knowExactly: {
        key: "tiw__successfulEvaluation__knowExactly",
        ru: "Now you know exactly how much you will save in Trade-In. It remains to sign an SMS agreement",
        en: "Now you know exactly how much you will save in Trade-In. It remains to sign an SMS agreement",
        kz: "Now you know exactly how much you will save in Trade-In. It remains to sign an SMS agreement",
        ua: "Now you know exactly how much you will save in Trade-In. It remains to sign an SMS agreement",
        pl: "Teraz już dokładnie wiesz, ile zaoszczędzisz w ramach programu Trade-In. Pozostaje tylko podpisać umowę SMS.",
        az: "Now you know exactly how much you will save in Trade-In. It remains to sign an SMS agreement",
    },
    tiw__pay: {
        key: "tiw__pay",
        ru: "Pay",
        en: "Pay",
        kz: "Pay",
        ua: "Pay",
        pl: "Zapłać",
        az: "Pay",
    },
    tiw__transaction__amount: {
        key: "tiw__transaction__amount",
        ru: "Transaction amount:",
        en: "Transaction amount:",
        kz: "Transaction amount:",
        ua: "Transaction amount:",
        pl: "Kwota transakcji:",
        az: "Transaction amount:",
    },
    tiw__successfulEvaluation__dataForContract: {
        key: "tiw__successfulEvaluation__dataForContract",
        ru: "Data for contract conclusion",
        en: "Data for contract conclusion",
        kz: "Data for contract conclusion",
        ua: "Data for contract conclusion",
        pl: "Dane do zawarcia umowy",
        az: "Data for contract conclusion",
    },
    tiw__successfulEvaluation__AddressOfResidence: {
        key: "tiw__successfulEvaluation__AddressOfResidence",
        ru: "Address of residence",
        en: "Address of residence",
        kz: "Address of residence",
        ua: "Address of residence",
        pl: "Adres zamieszkania",
        az: "Address of residence",
    },
    tiw__addToCartWithoutSms: {
        key: "tiw__addToCartWithoutSms",
        ru: "The agreement will be signed in the store upon receipt of the goods.",
        en: "The agreement will be signed in the store upon receipt of the goods.",
        kz: "The agreement will be signed in the store upon receipt of the goods.",
        ua: "The agreement will be signed in the store upon receipt of the goods.",
        pl: "Umowa zostanie podpisana w sklepie po otrzymaniu towaru.",
        az: "The agreement will be signed in the store upon receipt of the goods.",
    },
    tiw__voucherNumber: {
        key: "tiw__voucherNumber",
        ru: "Voucher number",
        en: "Voucher number",
        kz: "Voucher number",
        ua: "Voucher number",
        pl: "Numer bonu",
        az: "Voucher number",
    },
    tiw__voucher__copy__text: {
        key: "tiw__voucher__copy__text",
        ru: "Copy number",
        en: "Copy number",
        kz: "Copy number",
        ua: "Copy number",
        pl: "Skopiuj numer",
        az: "Copy number",
    },
    tiw__voucher__copied__text: {
        key: "tiw__voucher__copied__text",
        ru: "voucher copied",
        en: "voucher copied",
        kz: "voucher copied",
        ua: "voucher copied",
        pl: "Numer skopiowany",
        az: "voucher copied",
    },
    tiw__errors__mustBeNumber: {
        key: "tiw__errors__mustBeNumber",
        ru: "must be an [[NUMBER]]-digit number",
        en: "must be an [[NUMBER]]-digit number",
        kz: "must be an [[NUMBER]]-digit number",
        ua: "must be an [[NUMBER]]-digit number",
        pl: "musi być liczbą składającą się z [[NUMBER]] cyfr",
        az: "must be an [[NUMBER]]-digit number",
    },
    tiw__forms__PESEL: {
        key: "tiw__forms__PESEL",
        ru: "PESEL",
        en: "PESEL",
        kz: "PESEL",
        ua: "PESEL",
        pl: "PESEL",
        az: "PESEL",
    },
    tiw__forms__name: {
        key: "tiw__forms__name",
        ru: "Name",
        en: "Name",
        kz: "Name",
        ua: "Name",
        pl: "Imię",
        az: "Name",
    },
    tiw__forms__surname: {
        key: "tiw__forms__surname",
        ru: "Surname",
        en: "Surname",
        kz: "Surname",
        ua: "Surname",
        pl: "Nazwisko",
        az: "Surname",
    },
    tiw__forms__idNumber: {
        key: "tiw__forms__idNumber",
        ru: "ID Number",
        en: "ID Number",
        kz: "ID Number",
        ua: "ID Number",
        pl: "Numer dokumentu tożsamości ",
        az: "ID Number",
    },
    tiw__forms__dateOfIssue: {
        key: "tiw__forms__dateOfIssue",
        ru: "Date of Issue",
        en: "Date of Issue",
        kz: "Date of Issue",
        ua: "Date of Issue",
        pl: "Data wydania",
        az: "Date of Issue",
    },
    tiw__forms__expirationDate: {
        key: "tiw__forms__expirationDate",
        ru: "Expiration Date",
        en: "Expiration Date",
        kz: "Expiration Date",
        ua: "Expiration Date",
        pl: "Data ważności",
        az: "Expiration Date",
    },
    tiw__forms__postalCode: {
        key: "tiw__forms__postalCode",
        ru: "Postal code",
        en: "Postal code",
        kz: "Postal code",
        ua: "Postal code",
        pl: "Kod pocztowy",
        az: "Postal code",
    },
    tiw__forms__city: {
        key: "tiw__forms__city",
        ru: "City",
        en: "City",
        kz: "City",
        ua: "City",
        pl: "Miasto",
        az: "City",
    },
    tiw__forms__street: {
        key: "tiw__forms__street",
        ru: "Street",
        en: "Street",
        kz: "Street",
        ua: "Street",
        pl: "Ulica",
        az: "Street",
    },
    tiw__forms__houseNumber: {
        key: "tiw__forms__houseNumber",
        ru: "House number",
        en: "House number",
        kz: "House number",
        ua: "House number",
        pl: "Numer budynku",
        az: "House number",
    },
    tiw__forms__apartmentNumber: {
        key: "tiw__forms__apartmentNumber",
        ru: "Apartment number",
        en: "Apartment number",
        kz: "Apartment number",
        ua: "Apartment number",
        pl: "Numer mieszkania",
        az: "Apartment number",
    },
    tiw__forms__email: {
        key: "tiw__forms__email",
        ru: "Email",
        en: "Email",
        kz: "Email",
        ua: "Email",
        pl: "E-mail",
        az: "Email",
    },
    tiw__forms__phone: {
        key: "tiw__forms__phone",
        ru: "Phone",
        en: "Phone",
        kz: "Phone",
        ua: "Phone",
        pl: "Telefon",
        az: "Phone",
    },
    tiw__forms__name__recipient: {
        key: "tiw__forms__name__recipient",
        ru: "Recipient Name",
        en: "Recipient Name",
        kz: "Recipient Name",
        ua: "Recipient Name",
        pl: "Imię nadawcy",
        az: "Recipient Name",
    },
    tiw__forms__surname__recipient: {
        key: "tiw__forms__surname__recipient",
        ru: "Recipient surname",
        en: "Recipient surname",
        kz: "Recipient surname",
        ua: "Recipient surname",
        pl: "Nazwisko nadawcy",
        az: "Recipient surname",
    },
    tiw__forms__phone__recipient: {
        key: "tiw__forms__phone__recipient",
        ru: "Phone",
        en: "Phone",
        kz: "Phone",
        ua: "Phone",
        pl: "Numer telefonu",
        az: "Phone",
    },
    tiw__successful__b2b__failed__title: {
        key: "tiw__successful__b2b__failed__title",
        ru: "Contract Preparation Failed",
        en: "Contract Preparation Failed",
        kz: "Contract Preparation Failed",
        ua: "Contract Preparation Failed",
        pl: "Nie udało się przygotować umowy",
        az: "Contract Preparation Failed",
    },
    tiw__successful__b2b__failed__text: {
        key: "tiw__successful__b2b__failed__text",
        ru: "Contract Preparation Failed",
        en: "Contract Preparation Failed",
        kz: "Contract Preparation Failed",
        ua: "Contract Preparation Failed",
        pl: "Niestety nie możemy potwierdzić danych Twojej firmy w rejestrach rządowych. Upewnij się, że numer NIP, nazwa i pozostałe dane zostały wprowadzone prawidłowo i spróbuj ponownie.",
        az: "Contract Preparation Failed",
    },
    tiw__successful__b2b__failed__button: {
        key: "tiw__successful__b2b__failed__button",
        ru: "Try Again",
        en: "Try Again",
        kz: "Try Again",
        ua: "Try Again",
        pl: "Spróbuj ponownie",
        az: "Try Again",
    },
    tiw__person__repeatButton: {
        key: "tiw__person__repeatButton",
        ru: "Repeat authentication process",
        en: "Repeat authentication process",
        kz: "Repeat authentication process",
        ua: "Repeat authentication process",
        pl: "Powtórz proces uwierzytelniania",
        az: "Repeat authentication process",
    },
    tiw__person__upload__title: {
        key: "tiw__person__upload__title",
        ru: "Upload an image of your document",
        en: "Upload an image of your document",
        kz: "Upload an image of your document",
        ua: "Upload an image of your document",
        pl: "Prześlij obraz swojego dokumentu",
        az: "Upload an image of your document",
    },
    tiw__person__upload__documentGuide: {
        key: "tiw__person__upload__documentGuide",
        ru: "Document preparation guide",
        en: "Document preparation guide",
        kz: "Document preparation guide",
        ua: "Document preparation guide",
        pl: "Przewodnik po przygotowywaniu dokumentów",
        az: "Document preparation guide",
    },
    tiw__person__upload__documentGuide__1: {
        key: "tiw__person__upload__documentGuide__1",
        ru: "Prepare a clear photo/scan of the document",
        en: "Prepare a clear photo/scan of the document",
        kz: "Prepare a clear photo/scan of the document",
        ua: "Prepare a clear photo/scan of the document",
        pl: "Przygotuj wyraźne zdjęcie/skan dokumentu.",
        az: "Prepare a clear photo/scan of the document",
    },
    tiw__person__upload__documentGuide__2: {
        key: "tiw__person__upload__documentGuide__2",
        ru: "If the document is double-sided, take a photo of both sides",
        en: "If the document is double-sided, take a photo of both sides",
        kz: "If the document is double-sided, take a photo of both sides",
        ua: "If the document is double-sided, take a photo of both sides",
        pl: "Jeśli dokument jest dwustronny, zrób zdjęcie obu stron.",
        az: "If the document is double-sided, take a photo of both sides",
    },
    tiw__person__upload__documentGuide__3: {
        key: "tiw__person__upload__documentGuide__3",
        ru: "The document should be well-lit, without overexposed or dark areas",
        en: "The document should be well-lit, without overexposed or dark areas",
        kz: "The document should be well-lit, without overexposed or dark areas",
        ua: "The document should be well-lit, without overexposed or dark areas",
        pl: "Dokument powinien być dobrze oświetlony, bez prześwietlonych lub zaciemnionych obszarów.",
        az: "The document should be well-lit, without overexposed or dark areas",
    },
    tiw__person__upload__documentGuide__4: {
        key: "tiw__person__upload__documentGuide__4",
        ru: "Do not use a flash, glare reduces the accuracy of recognition",
        en: "Do not use a flash, glare reduces the accuracy of recognition",
        kz: "Do not use a flash, glare reduces the accuracy of recognition",
        ua: "Do not use a flash, glare reduces the accuracy of recognition",
        pl: "Nie używaj lampy błyskowej, ponieważ odblaski zmniejszają dokładność rozpoznawania.",
        az: "Do not use a flash, glare reduces the accuracy of recognition",
    },
    tiw__person__upload__documentGuide__5: {
        key: "tiw__person__upload__documentGuide__5",
        ru: "The image must be sharp and free of blur",
        en: "The image must be sharp and free of blur",
        kz: "The image must be sharp and free of blur",
        ua: "The image must be sharp and free of blur",
        pl: "Obraz musi być ostry i pozbawiony rozmycia.",
        az: "The image must be sharp and free of blur",
    },
    tiw__person__upload__documentGuide__6: {
        key: "tiw__person__upload__documentGuide__6",
        ru: "The camera's tilt angle should not exceed ~10° horizontally or vertically",
        en: "The camera's tilt angle should not exceed ~10° horizontally or vertically",
        kz: "The camera's tilt angle should not exceed ~10° horizontally or vertically",
        ua: "The camera's tilt angle should not exceed ~10° horizontally or vertically",
        pl: "Kąt nachylenia kamery nie powinien przekraczać ~10° w poziomie ani w pionie.",
        az: "The camera's tilt angle should not exceed ~10° horizontally or vertically",
    },
    tiw__person__upload__documentGuide__7: {
        key: "tiw__person__upload__documentGuide__7",
        ru: "The document should occupy ~70–80% of the frame; do not leave too little or too much background (no more than 20–30% of the space around it)",
        en: "The document should occupy ~70–80% of the frame; do not leave too little or too much background (no more than 20–30% of the space around it)",
        kz: "The document should occupy ~70–80% of the frame; do not leave too little or too much background (no more than 20–30% of the space around it)",
        ua: "The document should occupy ~70–80% of the frame; do not leave too little or too much background (no more than 20–30% of the space around it)",
        pl: "Dokument powinien zajmować około 70–80% kadru; nie pozostawiaj zbyt mało lub zbyt dużo tła (nie więcej niż 20–30% przestrzeni wokół niego).",
        az: "The document should occupy ~70–80% of the frame; do not leave too little or too much background (no more than 20–30% of the space around it)",
    },
    tiw__person__upload__documentGuide__8: {
        key: "tiw__person__upload__documentGuide__8",
        ru: 'The document should have a noticeable tonal difference from the background (avoid "light on light" and "dark on dark")',
        en: 'The document should have a noticeable tonal difference from the background (avoid "light on light" and "dark on dark")',
        kz: 'The document should have a noticeable tonal difference from the background (avoid "light on light" and "dark on dark")',
        ua: 'The document should have a noticeable tonal difference from the background (avoid "light on light" and "dark on dark")',
        pl: "Dokument powinien mieć wyraźną różnicę tonacyjną w stosunku do tła (należy unikać połączeń „jasne na jasnym” i „ciemne na ciemnym”).",
        az: 'The document should have a noticeable tonal difference from the background (avoid "light on light" and "dark on dark")',
    },
    tiw__person__upload__documentGuide__9: {
        key: "tiw__person__upload__documentGuide__9",
        ru: "A camera with at least Full HD (1920×1080) resolution and autofocus is recommended",
        en: "A camera with at least Full HD (1920×1080) resolution and autofocus is recommended",
        kz: "A camera with at least Full HD (1920×1080) resolution and autofocus is recommended",
        ua: "A camera with at least Full HD (1920×1080) resolution and autofocus is recommended",
        pl: "Zalecana jest kamera o rozdzielczości co najmniej Full HD (1920×1080) i autofokusie.",
        az: "A camera with at least Full HD (1920×1080) resolution and autofocus is recommended",
    },
    tiw__person__upload__documentGuide__10: {
        key: "tiw__person__upload__documentGuide__10",
        ru: "Fingers or other objects should not cover the document's data",
        en: "Fingers or other objects should not cover the document's data",
        kz: "Fingers or other objects should not cover the document's data",
        ua: "Fingers or other objects should not cover the document's data",
        pl: "Palce ani inne przedmioty nie powinny zasłaniać danych zawartych w dokumencie.",
        az: "Fingers or other objects should not cover the document's data",
    },
    tiw__person__upload__documentGuide__11: {
        key: "tiw__person__upload__documentGuide__11",
        ru: "The document's pages should be aligned; details must be clearly visible (avoid skewed or perspective distortions)",
        en: "The document's pages should be aligned; details must be clearly visible (avoid skewed or perspective distortions)",
        kz: "The document's pages should be aligned; details must be clearly visible (avoid skewed or perspective distortions)",
        ua: "The document's pages should be aligned; details must be clearly visible (avoid skewed or perspective distortions)",
        pl: "Strony dokumentu powinny być wyrównane; szczegóły muszą być wyraźnie widoczne (należy unikać przekrzywień lub zniekształceń perspektywicznych).",
        az: "The document's pages should be aligned; details must be clearly visible (avoid skewed or perspective distortions)",
    },
    tiw__person__upload__howToUpload: {
        key: "tiw__person__upload__howToUpload",
        ru: "How to upload documents",
        en: "How to upload documents",
        kz: "How to upload documents",
        ua: "How to upload documents",
        pl: "Jak przesłać dokumenty",
        az: "How to upload documents",
    },
    tiw__person__upload__howToUpload__1: {
        key: "tiw__person__upload__howToUpload__1",
        ru: 'Click "Upload document" and select the file',
        en: 'Click "Upload document" and select the file',
        kz: 'Click "Upload document" and select the file',
        ua: 'Click "Upload document" and select the file',
        pl: "Kliknij „Prześlij dokument” i wybierz plik.",
        az: 'Click "Upload document" and select the file',
    },
    tiw__person__upload__howToUpload__2: {
        key: "tiw__person__upload__howToUpload__2",
        ru: 'Click the "Continue" button',
        en: 'Click the "Continue" button',
        kz: 'Click the "Continue" button',
        ua: 'Click the "Continue" button',
        pl: "Kliknij przycisk „Kontynuuj”.",
        az: 'Click the "Continue" button',
    },
    tiw__person__upload__howToUpload__3: {
        key: "tiw__person__upload__howToUpload__3",
        ru: "Wait for the check to complete",
        en: "Wait for the check to complete",
        kz: "Wait for the check to complete",
        ua: "Wait for the check to complete",
        pl: "Poczekaj na zakończenie sprawdzania.",
        az: "Wait for the check to complete",
    },
    tiw__person__upload__howToUpload__4: {
        key: "tiw__person__upload__howToUpload__4",
        ru: "If the check fails, upload a better quality photo or another copy of the document",
        en: "If the check fails, upload a better quality photo or another copy of the document",
        kz: "If the check fails, upload a better quality photo or another copy of the document",
        ua: "If the check fails, upload a better quality photo or another copy of the document",
        pl: "Jeśli weryfikacja nie powiedzie się, prześlij zdjęcie lepszej jakości lub inną kopię dokumentu.",
        az: "If the check fails, upload a better quality photo or another copy of the document",
    },
    tiw__person__upload__howToUpload__5: {
        key: "tiw__person__upload__howToUpload__5",
        ru: "You can change your research plan",
        en: "You can change your research plan",
        kz: "You can change your research plan",
        ua: "You can change your research plan",
        pl: "Możesz zmienić swój plan badań.",
        az: "You can change your research plan",
    },
    tiw__person__upload__examples: {
        key: "tiw__person__upload__examples",
        ru: "Examples of documents",
        en: "Examples of documents",
        kz: "Examples of documents",
        ua: "Examples of documents",
        pl: "Przykłady dokumentów",
        az: "Examples of documents",
    },
    tiw__person__upload__documentImageFront: {
        key: "tiw__person__upload__documentImageFront",
        ru: "Document front side",
        en: "Document front side",
        kz: "Document front side",
        ua: "Document front side",
        pl: "Strona przednia dokumentu",
        az: "Document front side",
    },
    tiw__person__upload__documentImageBack: {
        key: "tiw__person__upload__documentImageBack",
        ru: "Document back side",
        en: "Document back side",
        kz: "Document back side",
        ua: "Document back side",
        pl: "Tył dokumentu",
        az: "Document back side",
    },
    tiw__person__upload__image: {
        key: "tiw__person__upload__image",
        ru: "Upload an image",
        en: "Upload an image",
        kz: "Upload an image",
        ua: "Upload an image",
        pl: "Prześlij obraz",
        az: "Upload an image",
    },
    tiw__person__upload__images: {
        key: "tiw__person__upload__images",
        ru: "Upload more images",
        en: "Upload more images",
        kz: "Upload more images",
        ua: "Upload more images",
        pl: "Prześlij więcej zdjęć",
        az: "Upload more images",
    },
    tiw__person__upload__confirmAccuracy: {
        key: "tiw__person__upload__confirmAccuracy",
        ru: "I confirm the accuracy of the data",
        en: "I confirm the accuracy of the data",
        kz: "I confirm the accuracy of the data",
        ua: "I confirm the accuracy of the data",
        pl: "Potwierdzam poprawność danych.",
        az: "I confirm the accuracy of the data",
    },
    tiw__dateOfBirth: {
        key: "tiw__dateOfBirth",
        ru: "Date of Birth",
        en: "Date of Birth",
        kz: "Date of Birth",
        ua: "Date of Birth",
        pl: "Data urodzenia",
        az: "Date of Birth",
    },
    tiw__placeOfBirth: {
        key: "tiw__placeOfBirth",
        ru: "Place of birth",
        en: "Place of birth",
        kz: "Place of birth",
        ua: "Place of birth",
        pl: "Miejsce urodzenia",
        az: "Place of birth",
    },
    tiw__issuingState: {
        key: "tiw__issuingState",
        ru: "Issuing state",
        en: "Issuing state",
        kz: "Issuing state",
        ua: "Issuing state",
        pl: "Państwo wydające",
        az: "Issuing state",
    },
    tiw__nationality: {
        key: "tiw__nationality",
        ru: "Nationality",
        en: "Nationality",
        kz: "Nationality",
        ua: "Nationality",
        pl: "Obywatelstwo",
        az: "Nationality",
    },
    tiw__identityCardNumber: {
        key: "tiw__identityCardNumber",
        ru: "Identity card number",
        en: "Identity card number",
        kz: "Identity card number",
        ua: "Identity card number",
        pl: "Numer dowodu osobistego",
        az: "Identity card number",
    },
    tiw__pesel: {
        key: "tiw__pesel",
        ru: "PESEL registry number",
        en: "PESEL registry number",
        kz: "PESEL registry number",
        ua: "PESEL registry number",
        pl: "Numer ewidencyjny PESEL",
        az: "PESEL registry number",
    },
    tiw__nationalityCode: {
        key: "tiw__nationalityCode",
        ru: "Nationality code",
        en: "Nationality code",
        kz: "Nationality code",
        ua: "Nationality code",
        pl: "Kod narodowości",
        az: "Nationality code",
    },
    tiw__nameOfIssuingAuthority: {
        key: "tiw__nameOfIssuingAuthority",
        ru: "Name of the issuing authority",
        en: "Name of the issuing authority",
        kz: "Name of the issuing authority",
        ua: "Name of the issuing authority",
        pl: "Nazwa organu wydającego",
        az: "Name of the issuing authority",
    },
    tiw__dateOfExpiry: {
        key: "tiw__dateOfExpiry",
        ru: "Date of expiry",
        en: "Date of expiry",
        kz: "Date of expiry",
        ua: "Date of expiry",
        pl: "Data ważności",
        az: "Date of expiry",
    },
    tiw__male: {
        key: "tiw__male",
        ru: "Male",
        en: "Male",
        kz: "Male",
        ua: "Male",
        pl: "Mężczyzna",
        az: "Male",
    },
    tiw__female: {
        key: "tiw__female",
        ru: "Female",
        en: "Female",
        kz: "Female",
        ua: "Female",
        pl: "Kobieta",
        az: "Female",
    },
    tiw__upload__error__size: {
        key: "tiw__upload__error__size",
        ru: "The file size must not exceed 5MB",
        en: "The file size must not exceed 5MB",
        kz: "The file size must not exceed 5MB",
        ua: "The file size must not exceed 5MB",
        pl: "Rozmiar pliku nie może przekraczać 5 MB.",
        az: "The file size must not exceed 5MB",
    },
    tiw__successfulEvaluation__companyName: {
        key: "tiw__successfulEvaluation__companyName",
        ru: "Company name",
        en: "Company name",
        kz: "Company name",
        ua: "Company name",
        pl: "Nazwa firmy",
        az: "Company name",
    },
    tiw__successfulEvaluation__nameCompanyRepresentative: {
        key: "tiw__successfulEvaluation__nameCompanyRepresentative",
        ru: "Name of the company representative",
        en: "Name of the company representative",
        kz: "Name of the company representative",
        ua: "Name of the company representative",
        pl: "Imię przedstawiciela firmy",
        az: "Name of the company representative",
    },
    tiw__successfulEvaluation__lastNameCompanyRepresentative: {
        key: "tiw__successfulEvaluation__lastNameCompanyRepresentative",
        ru: "Last name of the company representative",
        en: "Last name of the company representative",
        kz: "Last name of the company representative",
        ua: "Last name of the company representative",
        pl: "Nazwisko przedstawiciela firmy",
        az: "Last name of the company representative",
    },
    tiw__successfulEvaluation__b2b__id: {
        key: "tiw__successfulEvaluation__b2b__id",
        ru: "Identification number",
        en: "Identification number",
        kz: "Identification number",
        ua: "Identification number",
        pl: "Numer PESEL",
        az: "Identification number",
    },
    tiw__successfulEvaluation__b2b__idOrNumber: {
        key: "tiw__successfulEvaluation__b2b__idOrNumber",
        ru: "ID or passport number",
        en: "ID or passport number",
        kz: "ID or passport number",
        ua: "ID or passport number",
        pl: "Numer dowodu osobistego lub paszportu",
        az: "ID or passport number",
    },
    tiw__successfulEvaluation__b2b__owner: {
        key: "tiw__successfulEvaluation__b2b__owner",
        ru: "I declare that all company data I have provided is true and that I am its owner/representative",
        en: "I declare that all company data I have provided is true and that I am its owner/representative",
        kz: "I declare that all company data I have provided is true and that I am its owner/representative",
        ua: "I declare that all company data I have provided is true and that I am its owner/representative",
        pl: "Oświadczam, że wszystkie podane przeze mnie dane firmy są prawdziwe i jestem jej właścicielem/przedstawicielem",
        az: "I declare that all company data I have provided is true and that I am its owner/representative",
    },
    tiw__successfulEvaluation__b2b__vat: {
        key: "tiw__successfulEvaluation__b2b__vat",
        ru: "I declare that I am an active VAT payer",
        en: "I declare that I am an active VAT payer",
        kz: "I declare that I am an active VAT payer",
        ua: "I declare that I am an active VAT payer",
        pl: "Oświadczam, że firma jest czynnym podatnikiem VAT",
        az: "I declare that I am an active VAT payer",
    },
    tiw__confirm: {
        key: "tiw__confirm",
        ru: "confirm",
        en: "confirm",
        kz: "confirm",
        ua: "confirm",
        pl: "potwierdzać",
        az: "confirm",
    },
    tiw__confirmBelowPrice__title: {
        key: "tiw__confirmBelowPrice__title",
        ru: "Important!",
        en: "Important!",
        kz: "Important!",
        ua: "Important!",
        pl: "Ważna informacja",
        az: "Important!",
    },
    tiw__confirmBelowPrice__text: {
        key: "tiw__confirmBelowPrice__text",
        ru: "To continue, please confirm the information below.",
        en: "To continue, please confirm the information below.",
        kz: "To continue, please confirm the information below.",
        ua: "To continue, please confirm the information below.",
        pl: "Aby kontynuować, prosimy o potwierdzenie poniższej informacji.",
        az: "To continue, please confirm the information below.",
    },
    tiw__confirmBelowPrice__checkbox: {
        key: "tiw__confirmBelowPrice__checkbox",
        ru: "I confirm that by choosing this method to complete the contract process, I have knowingly agreed to <b>a device price equal to 70% of its original valuation.</b>",
        en: "I confirm that by choosing this method to complete the contract process, I have knowingly agreed to <b>a device price equal to 70% of its original valuation.</b>",
        kz: "I confirm that by choosing this method to complete the contract process, I have knowingly agreed to <b>a device price equal to 70% of its original valuation.</b>",
        ua: "I confirm that by choosing this method to complete the contract process, I have knowingly agreed to <b>a device price equal to 70% of its original valuation.</b>",
        pl: "Potwierdzam, że wybierając ten sposób dokończenia procesu zawarcia umowy, świadomie zgodziłam/em <b>się na cenę urządzenia, która stanowi 70% jego pierwotnej wyceny.</b>",
        az: "I confirm that by choosing this method to complete the contract process, I have knowingly agreed to <b>a device price equal to 70% of its original valuation.</b>",
    },
};
export default TRANSLATIONS;
